import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useAuth } from '../pages/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBox,
    faBarcode,
    faTag,
    faBuilding,
    faBalanceScale,
    faRupeeSign,
    faCalculator,
    faExclamationTriangle,
    faCalendarAlt,
    faSave,
    faTimes,
    faCheckCircle,
    faStore,
    faExchangeAlt,
    faWarehouse,
    faPercent,
    faQrcode,
    faBoxes,
    faLayerGroup,
    faCubes,
    faFileAlt,
    faSpinner,
    faChevronDown,
    faSearch,
    faPills,
    faTablets,
    faArrowRight,
    faChartLine,
    faCoins,
    faGift,
    faMoneyBillWave
} from '@fortawesome/free-solid-svg-icons';
import "./PharmacyForm.css";

const createProductsTranslator = () => {
    let cache = new Map();

    const urduTranslations = {
        addProduct: 'محفوظ کریں',
        editProduct: 'ترمیم کریں',
        fillDetails: 'براہ کرم تفصیلات درج کریں',
        productDetails: 'مصنوعات کی تفصیلات',
        productName: 'مصنوعات کا نام',
        productCode: 'مصنوعات کا کوڈ',
        batchNumber: 'بیچ نمبر',
        barcode: 'بارکوڈ',
        category: 'زمرہ',
        company: 'کمپنی / برانڈ',
        unit: 'یونٹ',
        costPrice: 'لاگت قیمت',
        sellingPrice: 'فروخت قیمت',
        quantity: 'مقدار',
        quantityAlert: 'کم اسٹاک الرٹ',
        expiryDate: 'میعاد ختم ہونے کی تاریخ',
        date: 'تاریخ',
        addProductButton: 'محفوظ کریں',
        updateProduct: 'اپ ڈیٹ کریں',
        clearButton: 'صاف کریں',
        adding: 'محفوظ ہو رہا ہے...',
        updating: 'اپ ڈیٹ ہو رہا ہے...',
        productSaved: 'مصنوعات کامیابی سے محفوظ ہو گئی!',
        productUpdated: 'مصنوعات کامیابی سے اپ ڈیٹ ہو گئی!',
        failedAdd: 'مصنوعات محفوظ کرنے میں ناکامی',
        failedUpdate: 'مصنوعات اپ ڈیٹ کرنے میں ناکامی',
        networkError: 'نیٹ ورک کی خرابی',
        nameRequired: 'مصنوعات کا نام ضروری ہے',
        nameTooShort: 'نام کم از کم 2 حروف کا ہونا چاہیے',
        batchRequired: 'بیچ نمبر ضروری ہے',
        batchExists: 'یہ بیچ نمبر پہلے سے موجود ہے',
        productCodeExists: 'یہ مصنوعات کا کوڈ پہلے سے موجود ہے',
        unitRequired: 'یونٹ ضروری ہے',
        costPriceRequired: 'لاگت قیمت ضروری ہے',
        sellingPriceRequired: 'فروخت قیمت ضروری ہے',
        quantityRequired: 'مقدار ضروری ہے',
        alertRequired: 'کم اسٹاک الرٹ ضروری ہے',
        invalidPrice: 'براہ کرم درست قیمت درج کریں',
        invalidQuantity: 'براہ کرم درست مقدار درج کریں',
        expiryPast: 'میعاد ختم ہونے کی تاریخ ماضی میں نہیں ہو سکتی',
        success: 'کامیابی',
        error: 'خرابی',
        warning: 'انتباہ',
        selectShop: 'پہلے دکان منتخب کریں',
        currentShop: 'موجودہ دکان',
        willAddToShop: 'مصنوعات اس دکان میں شامل ہو گی',
        noShopSelected: 'کوئی دکان منتخب نہیں۔ براہ کرم پہلے دکان تبدیل کریں',
        switchShop: 'دکان تبدیل کریں',
        shopSwitched: 'دکان کامیابی سے تبدیل ہو گئی',
        shopSwitchFailed: 'دکان تبدیل کرنے میں ناکامی',
        loadingShops: 'دکانیں لوڈ ہو رہی ہیں...',
        noShops: 'کوئی دکان دستیاب نہیں',
        active: 'فعال',
        current: 'موجودہ',
        profitMargin: 'منافع کا مارجن',
        markup: 'مارک اپ',
        selectCategory: 'زمرہ منتخب کریں',
        selectUnit: 'یونٹ منتخب کریں',
        optional: 'اختیاری',
        enterProductName: 'مصنوعات کا نام درج کریں',
        enterProductCode: 'مصنوعات کا کوڈ درج کریں',
        enterBatchNumber: 'بیچ نمبر درج کریں',
        barcodeAutoGenerate: 'بارکوڈ خودکار جنریٹ ہو گا',
        enterCompany: 'کمپنی/برانڈ درج کریں',
        zeroPlaceholder: '0.0',
        zeroPlaceholderDecimal: '0.00',
        zeroPlaceholderThreeDecimal: '0.000',
        packingType: 'پیکنگ کی قسم',
        subPackingType: 'ذیلی پیکنگ کی قسم',
        itemsPerPack: 'فی پیک اشیاء',
        unitOfMeasure: 'پیمائش کی اکائی',
        totalQuantity: 'کل مقدار',
        costPerPack: 'فی پیک لاگت',
        sellingPerPack: 'فی پیک فروخت قیمت',
        selectPackingType: 'پیکنگ کی قسم منتخب کریں',
        enterItemsPerPack: 'فی پیک اشیاء کی تعداد درج کریں',
        costPerUnit: 'فی یونٹ لاگت',
        sellPricePerUnit: 'فی یونٹ فروخت قیمت',
        bquantity: 'کل مقدار (بلک)',
        box: 'باکس',
        carton: 'کارٹن',
        crate: 'کریٹ',
        packet: 'پیکٹ',
        bundle: 'بنڈل',
        bottle: 'بوتل',
        can: 'کین',
        piece: 'ٹکڑا',
        '1_liter': '1 لیٹر',
        '1.5_liter': '1.5 لیٹر',
        '2_liter': '2 لیٹر',
        '3_liter': '3 لیٹر',
        '5_liter': '5 لیٹر',
        draftLoaded: 'ڈرافٹ لوڈ ہو گیا',
        draftCleared: 'ڈرافٹ صاف کر دیا گیا',
        draftExists: 'پہلے سے محفوظ ڈرافٹ موجود ہے',
        retailPerPack: 'فی پیک ریٹیل قیمت',
        retailPerUnit: 'فی یونٹ ریٹیل قیمت',
        sellPricePerPack: 'فی پیک فروخت قیمت',
        unitsPerPack: 'فی پیک یونٹس',
        mrp: 'MRP (زیادہ سے زیادہ خوردہ قیمت)',
        tradePercent: 'تجارتی قیمت %',
        extraPercent: 'اضافی ڈسکاؤنٹ %',
        bonusBuy: 'بونس: خریدیں',
        bonusFree: 'بونس: مفت حاصل کریں',
        effectiveCostPrice: 'مؤثر لاگت قیمت',
        effectiveDiscountPercent: 'مؤثر ڈسکاؤنٹ %',
        autoCalculated: '(خودکار حساب)',
        saveDraft: 'ڈرافٹ محفوظ کریں',
        drafts: 'ڈرافٹس',
        savedDrafts: 'محفوظ ڈرافٹس',
        noDraftsSaved: 'کوئی ڈرافٹ محفوظ نہیں',
        packContent: 'پیک کا مواد (کل گولیاں / کیپسول)',
        bonusStockQuantity: 'بونس اسٹاک مقدار',
        actualStockQuantity: 'اصل اسٹاک مقدار (بونس سمیت)',
        mrpPerPack: 'MRP فی پیک (باکس/یونٹ)',
        mrpPerStrip: 'MRP فی سٹرپ / یونٹ',
        mrpPerTablet: 'MRP فی گولی / کیپسول',
        profitMargin: 'منافع کا مارجن',
        marginPerPack: 'منافع فی پیک',
        marginPerUnit: 'منافع فی یونٹ',
        marginPerTablet: 'منافع فی گولی',
        discounts: 'ڈسکاؤنٹس',
        bonusDetails: 'بونس کی تفصیلات',
        costPrices: 'لاگت کی قیمتیں',
        profitAnalysis: 'منافع کا تجزیہ'
    };

    const defaultTexts = {
        addProduct: 'Add Stock',
        editProduct: 'Edit Stock',
        fillDetails: 'Fill in the stock details below',
        productDetails: 'Product Details',
        productName: 'Product Name',
        productCode: 'Product Code / Grade',
        batchNumber: 'Batch Number',
        barcode: 'Barcode',
        category: 'Category',
        company: 'Company / Brand',
        unit: 'Unit',
        costPrice: 'Cost Price',
        sellingPrice: 'Retail Price',
        quantity: 'Quantity',
        quantityAlert: 'Low Stock Alert',
        expiryDate: 'Expiry Date',
        date: 'Date',
        addProductButton: 'Save Product',
        updateProduct: 'Update Product',
        clearButton: 'Clear',
        adding: 'Adding...',
        updating: 'Updating...',
        productSaved: 'Product saved successfully!',
        productUpdated: 'Product updated successfully!',
        failedAdd: 'Failed to save product',
        failedUpdate: 'Failed to update product',
        networkError: 'Network error occurred',
        nameRequired: 'Product name is required',
        nameTooShort: 'Name must be at least 2 characters',
        batchRequired: 'Batch number is required',
        batchExists: 'This batch number already exists',
        productCodeExists: 'This product code already exists',
        unitRequired: 'Unit is required',
        costPriceRequired: 'Cost price is required',
        sellingPriceRequired: 'Retail price is required',
        quantityRequired: 'Quantity is required',
        alertRequired: 'Low stock alert quantity is required',
        invalidPrice: 'Please enter a valid price',
        invalidQuantity: 'Please enter a valid quantity',
        expiryPast: 'Expiry date cannot be in the past',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        selectShop: 'Select a shop first',
        currentShop: 'Current Shop',
        willAddToShop: 'Product will be added to this shop',
        noShopSelected: 'No shop selected. Please switch to a shop first.',
        switchShop: 'Switch Shop',
        shopSwitched: 'Shop switched successfully',
        shopSwitchFailed: 'Failed to switch shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        active: 'Active',
        current: 'Current',
        profitMargin: 'Profit Margin',
        markup: 'Markup',
        selectCategory: 'Select category',
        selectUnit: 'Select unit',
        optional: 'Optional',
        enterProductName: 'Enter product name',
        enterProductCode: 'Enter product code',
        enterBatchNumber: 'Enter batch number',
        barcodeAutoGenerate: 'Barcode will auto-generate',
        enterCompany: 'Enter company/brand',
        zeroPlaceholder: '0.0',
        zeroPlaceholderDecimal: '0.00',
        zeroPlaceholderThreeDecimal: '0.000',
        packingType: 'Packing Type',
        subPackingType: 'Sub Packing Type',
        itemsPerPack: 'Items Per Pack',
        unitOfMeasure: 'Unit of Measure',
        totalQuantity: 'Total Quantity',
        costPerPack: 'Cost Per Pack',
        sellingPerPack: 'Retail Price Per Pack',
        selectPackingType: 'Select packing type',
        enterItemsPerPack: 'Enter items per pack',
        costPerUnit: 'Cost per Unit',
        sellPricePerUnit: 'Retail per Unit',
        bquantity: 'BQuantity',
        box: 'Box',
        carton: 'Carton',
        crate: 'Crate',
        packet: 'Packet',
        bundle: 'Bundle',
        bottle: 'Bottle',
        can: 'Can',
        piece: 'Piece',
        '1_liter': '1 Liter',
        '1.5_liter': '1.5 Liter',
        '2_liter': '2 Liters',
        '3_liter': '3 Liters',
        '5_liter': '5 Liters',
        draftLoaded: 'Draft loaded',
        draftCleared: 'Draft cleared',
        draftExists: 'A saved draft exists',
        retailPerPack: 'Cost Per Pack',
        retailPerUnit: 'Cost Per Unit',
        sellPricePerPack: 'Retail Price Per Pack',
        unitsPerPack: 'Units Per Pack',
        mrp: 'MRP (Max Retail Price)',
        tradePercent: 'Trade Price %',
        extraPercent: 'Extra Discount %',
        bonusBuy: 'Bonus: Buy',
        bonusFree: 'Bonus: Get Free',
        effectiveCostPrice: 'Cost Price',
        effectiveDiscountPercent: 'Effective Discount %',
        autoCalculated: '(Auto-calculated)',
        saveDraft: 'Save Draft',
        drafts: 'Drafts',
        savedDrafts: 'Saved Drafts',
        noDraftsSaved: 'No drafts saved',
        packContent: 'Pack Content (Total Tablets / Capsules)',
        bonusStockQuantity: 'Bonus Stock Quantity',
        actualStockQuantity: 'Actual Stock Quantity (incl. Bonus)',
        mrpPerPack: 'MRP per Pack (Box/Unit)',
        mrpPerStrip: 'MRP per Strip / Unit',
        mrpPerTablet: 'MRP per Tablet / Capsule',
        profitMargin: 'Profit Margin',
        marginPerPack: 'Margin per Pack',
        marginPerUnit: 'Margin per Unit',
        marginPerTablet: 'Margin per Tablet',
        discounts: 'Discounts',
        bonusDetails: 'Bonus Details',
        costPrices: 'Cost Prices',
        profitAnalysis: 'Profit Analysis'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') return defaultTexts;
        if (lang === 'ur') return urduTranslations;
        return defaultTexts;
    };

    return { getTranslations };
};

const productsTranslator = createProductsTranslator();

const getUnitDisplayLabel = (unitOfMeasure) => {
    const labels = {
        '1_liter': 'Liter', '1.5_liter': 'Liter', '2_liter': 'Liter',
        '3_liter': 'Liter', '5_liter': 'Liter',
        '200_ml': 'Milliliter', '250_ml': 'Milliliter', '300_ml': 'Milliliter',
        '350_ml': 'Milliliter', '400_ml': 'Milliliter', '450_ml': 'Milliliter',
        '500_ml': 'Milliliter',
        '0.5_liter': 'Liter', '0.7_liter': 'Liter', '1_liter_alt': 'Liter',
        '2_liter_alt': 'Liter', '3_liter_alt': 'Liter', '4_liter': 'Liter',
        '5_liter_alt': 'Liter', '6_liter': 'Liter', '7_liter': 'Liter',
        '10_liter': 'Liter', '20_liter': 'Liter', '60_liter': 'Liter',
        '208_liter': 'Liter', 'milliliter': 'Milliliter', 'kilogram': 'Kilogram',
        'gram': 'Gram', 'piece': 'Piece', 'dozen': 'Dozen', 'box': 'Box',
        'packet': 'Packet', 'can': 'Can', 'bottle': 'Bottle',
        'tablet': 'Tablet', 'capsule': 'Capsule', 'strip': 'Strip',
        'vial': 'Vial', 'ampoule': 'Ampoule', 'sachet': 'Sachet', 'tube': 'Tube'
    };
    return labels[unitOfMeasure] || 'Unit';
};

const getPluralUnitLabel = (label) => {
    const plurals = {
        'Liter': 'Liters', 'Milliliter': 'Milliliters', 'Kilogram': 'Kilograms',
        'Gram': 'Grams', 'Piece': 'Pieces', 'Dozen': 'Dozens', 'Box': 'Boxes',
        'Packet': 'Packets', 'Can': 'Cans', 'Bottle': 'Bottles',
        'Tablet': 'Tablets', 'Capsule': 'Capsules', 'Strip': 'Strips',
        'Vial': 'Vials', 'Ampoule': 'Ampoules', 'Sachet': 'Sachets',
        'Tube': 'Tubes', 'Unit': 'Units'
    };
    return plurals[label] || label + 's';
};

const calculateSellPricePerUnit = (sellPerPack, itemsPerPack) => {
    if (sellPerPack <= 0 || itemsPerPack <= 0) return 0;
    return sellPerPack / itemsPerPack;
};

const calculateBQuantity = (itemsPerPack, unitOfMeasure, totalQuantity) => {
    if (itemsPerPack <= 0 || totalQuantity <= 0 || !unitOfMeasure) return '';
    const unitValue = 1;
    const totalItems = itemsPerPack * totalQuantity;
    const bulkValue = totalItems * unitValue;
    const unitLabel = getUnitDisplayLabel(unitOfMeasure);

    let formattedValue;
    if (Math.floor(bulkValue) === bulkValue) {
        formattedValue = bulkValue.toFixed(0);
    } else {
        formattedValue = bulkValue.toFixed(2);
    }
    const finalLabel = bulkValue !== 1 ? getPluralUnitLabel(unitLabel) : unitLabel;
    return `${formattedValue} ${finalLabel}`;
};

const calculateBonusStock = (purchasedQuantity, bonusBuy, bonusFree) => {
    const qty = parseFloat(purchasedQuantity) || 0;
    const buy = parseInt(bonusBuy) || 0;
    const free = parseInt(bonusFree) || 0;

    if (qty <= 0 || buy <= 0 || free <= 0) {
        return { bonusStockQuantity: 0, actualStockQuantity: qty };
    }

    const bonusSets = Math.floor(qty / buy);
    const bonusStockQuantity = bonusSets * free;
    const actualStockQuantity = qty + bonusStockQuantity;

    return { bonusStockQuantity, actualStockQuantity };
};

const formatQuantityValue = (value) => {
    if (!value || value <= 0) return '';
    const rounded = Math.round(value * 1000) / 1000;
    return rounded.toString();
};

const parseSubPackingBaseUnits = (subPackingLabel, itemsPerPack, unitOfMeasure) => {
    const items = parseFloat(itemsPerPack) || 0;
    if (!items || !unitOfMeasure) {
        return { totalBaseUnits: 0, baseUnitLabel: '' };
    }

    if (unitOfMeasure === 'strip') {
        const match = subPackingLabel ? subPackingLabel.match(/(\d+)\s*x\s*(\d+)/i) : null;
        let unitsPerStrip = match ? parseInt(match[2], 10) : 0;
        if (!unitsPerStrip || unitsPerStrip <= 0) {
            unitsPerStrip = 1;
        }

        const isCapsule = subPackingLabel && /capsule/i.test(subPackingLabel);
        const baseUnitLabel = isCapsule ? 'Capsule' : 'Tablet';

        return {
            totalBaseUnits: items * unitsPerStrip,
            baseUnitLabel
        };
    }

    if (unitOfMeasure === 'tablet' || unitOfMeasure === 'capsule') {
        return {
            totalBaseUnits: items,
            baseUnitLabel: unitOfMeasure === 'capsule' ? 'Capsule' : 'Tablet'
        };
    }

    return {
        totalBaseUnits: items,
        baseUnitLabel: getUnitDisplayLabel(unitOfMeasure)
    };
};

const formatPackContent = (totalBaseUnits, baseUnitLabel) => {
    if (!totalBaseUnits || totalBaseUnits <= 0 || !baseUnitLabel) return '';

    let formattedValue;
    if (Math.floor(totalBaseUnits) === totalBaseUnits) {
        formattedValue = totalBaseUnits.toFixed(0);
    } else {
        formattedValue = totalBaseUnits.toFixed(2);
    }

    const label = totalBaseUnits !== 1 ? getPluralUnitLabel(baseUnitLabel) : baseUnitLabel;
    return `${formattedValue} ${label}`;
};

const calculateEffectiveCostPrice = (mrp, tradePercent, extraPercent, bonusBuy, bonusFree) => {
    if (!mrp || mrp <= 0) {
        return {
            effectiveCostPrice: 0,
            discountPercent: 0,
            totalQuantity: 0,
            perUnitCost: 0,
            basePrice: 0,
            bonusPerUnit: 0,
            mrpPerPackUnit: 0,
            mrpPerBaseUnit: 0
        };
    }

    let price = mrp;
    const tp = parseFloat(tradePercent) || 0;
    const extra = parseFloat(extraPercent) || 0;
    const buy = parseInt(bonusBuy) || 0;
    const free = parseInt(bonusFree) || 0;

    if (tp > 0) {
        price = price * (1 - tp / 100);
    }

    if (extra > 0) {
        price = price * (1 - extra / 100);
    }
    let totalQuantity = buy;
    let bonusPerUnit = 0;
    let effectiveCostPrice = price;
    let perUnitCost = 0;

    if (buy > 0 && free > 0) {
        bonusPerUnit = mrp / buy;
        effectiveCostPrice = price - bonusPerUnit;
        perUnitCost = effectiveCostPrice / buy;
    } else if (buy > 0 && free === 0) {
        perUnitCost = price / buy;
        effectiveCostPrice = price;
        bonusPerUnit = 0;
    } else {
        perUnitCost = price;
        effectiveCostPrice = price;
        bonusPerUnit = 0;
    }
    let discountPercent = 0;
    if (mrp > 0 && effectiveCostPrice > 0) {
        discountPercent = (1 - effectiveCostPrice / mrp) * 100;
    }
    return {
        effectiveCostPrice: Math.round(effectiveCostPrice * 100) / 100,
        effectiveCostPriceExact: effectiveCostPrice,
        discountPercent: Math.round(discountPercent * 100) / 100,
        totalQuantity: totalQuantity,
        perUnitCost: Math.round(perUnitCost * 100) / 100,
        bonusPerUnit: Math.round(bonusPerUnit * 100) / 100,
        basePrice: Math.round(price * 100) / 100,
        mrpPerPackUnit: mrp,
        mrpPerBaseUnit: 0
    };
};

// ============================================
// DETERMINE UNIT OR STRIP - NEW FUNCTION
// ============================================
const determineUnitOrStrip = (packingType, subPackingType, unitOfMeasure) => {
    // If packing type is 'box' and sub packing contains 'x' (like 1 x 10)
    if (packingType === 'box') {
        // Check if sub_packing_type contains pattern like '1x10' or '1x10_capsule'
        const match = subPackingType?.match(/^box_(\d+)x(\d+)(?:_capsule)?$/);
        if (match) {
            return 'strip'; // It's a strip packing
        }
        // Also check for other strip patterns
        if (subPackingType?.includes('x') && (unitOfMeasure === 'strip' || unitOfMeasure === 'tablet' || unitOfMeasure === 'capsule')) {
            return 'strip';
        }
        // Check for strip in the label
        if (subPackingType?.toLowerCase().includes('strip')) {
            return 'strip';
        }
        return 'unit';
    }
    
    // For other packing types, use the unit of measure
    return unitOfMeasure || 'unit';
};

// ============================================
// TOAST NOTIFICATION COMPONENT
// ============================================
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            case 'info': return faCheckCircle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            case 'info': return 'Info';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// ============================================
// SHOP SELECTOR MODAL
// ============================================
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="pharmacy_modal-overlay" onClick={onClose}>
            <div className="pharmacy_modal" onClick={e => e.stopPropagation()}>
                <div className="pharmacy_modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="pharmacy_modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="pharmacy_modal-body">
                    {loading ? (
                        <div className="pharmacy_loading-state">{translations.loadingShops || 'Loading shops...'}</div>
                    ) : shops.length === 0 ? (
                        <div className="pharmacy_empty-state">{translations.noShops || 'No shops available'}</div>
                    ) : (
                        shops.map((shop) => (
                            <div
                                key={shop.shop_id}
                                className={`pharmacy_shop-item ${currentShop?.shop_id === shop.shop_id ? 'pharmacy_active' : ''}`}
                                onClick={() => onSelectShop(shop)}
                            >
                                <div className="pharmacy_shop-info">
                                    <div className="pharmacy_shop-name">{shop.shop_name}</div>
                                    <div className="pharmacy_shop-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                </div>
                                {currentShop?.shop_id === shop.shop_id && (
                                    <div className="pharmacy_shop-badge">✓ {translations.current || 'Current'}</div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

// ============================================
// MAIN ADD PRODUCT COMPONENT
// ============================================
const PharmacyProductTax = ({ productId = null, onSuccess = null }) => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();

    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return user?.language || localStorage.getItem('ourzest_language') || 'en';
    });

    const productNameRef = useRef(null);
    const batchNoRef = useRef(null);

    // ============================================
    // DROPDOWN OPTIONS
    // ============================================

    const packingTypes = [
        { value: '', label: 'Select Packing Type' },
        { value: 'unit', label: 'Unit' },
        { value: 'box', label: 'Box' },
    ];

    const subPackingTypesMap = {
    unit: [
        { value: 'tablet', label: 'Tablet' },
        { value: 'capsule', label: 'Capsule' },
        { value: 'softgel', label: 'Softgel Capsule' },
        { value: 'chewable_tablet', label: 'Chewable Tablet' },
        { value: 'dispersible_tablet', label: 'Dispersible Tablet' },
        { value: 'effervescent_tablet', label: 'Effervescent Tablet' },
        { value: 'sublingual_tablet', label: 'Sublingual Tablet' },
        { value: 'buccal_tablet', label: 'Buccal Tablet' },
        { value: 'vial', label: 'Vial' },
        { value: 'ampoule', label: 'Ampoule' },
        { value: 'prefilled_syringe', label: 'Prefilled Syringe' },
        { value: 'cartridge', label: 'Cartridge' },
        { value: 'tube', label: 'Tube' },
        { value: 'dropper_bottle', label: 'Dropper Bottle' },
        { value: 'bottle', label: 'Bottle' },
        { value: 'sachet', label: 'Sachet' },
        { value: 'strip', label: 'Strip' },
        { value: 'blister', label: 'Blister' },
        { value: 'respule', label: 'Respule' },
        { value: 'inhaler', label: 'Inhaler' },
        { value: 'patch', label: 'Patch' },
        { value: 'suppository', label: 'Suppository' },
        { value: 'pessary', label: 'Pessary' },
        { value: 'piece', label: 'Piece' },
        { value: 'eye_drops', label: 'Eye Drops' },
        { value: 'ear_drops', label: 'Ear Drops' },
        { value: 'nasal_spray', label: 'Nasal Spray' },
        { value: 'syrup', label: 'Syrup' },
        { value: 'suspension', label: 'Suspension' },
        { value: 'emulsion', label: 'Emulsion' },
        { value: 'elixir', label: 'Elixir' }
    ],
    box: (() => {
    const options = [];
    const maxStrips = 20;
    const maxTablets = 100;
    
    // Helper function to generate options for a specific type
    const generateOptions = (type, labelSuffix) => {
        const result = [];
        // First number: strips (1 to 20)
        for (let strips = 1; strips <= maxStrips; strips++) {
            // Second number: tablets per strip (1 to 100)
            for (let tablets = 1; tablets <= maxTablets; tablets++) {
                const value = `box_${strips}x${tablets}${type ? '_' + type : ''}`;
                // Changed label format to "1 x 10 Tab"
                const label = `${strips} x ${tablets} ${labelSuffix}`;
                result.push({
                    value: value,
                    label: label,
                    itemsPerPack: strips,
                    unitOfMeasure: 'strip'
                });
            }
        }
        return result;
    };

    // Generate all options with proper labels
    const tabletOptions = generateOptions('tab', 'Tab');
    const capsuleOptions = generateOptions('capsule', 'Capsule');
    const sachetOptions = generateOptions('sachet', 'Sachet');
    const ampouleOptions = generateOptions('ampoule', 'Ampoule');
    const vialOptions = generateOptions('vial', 'Vial');
    const bottleOptions = generateOptions('bottle', 'Bottle');
    const tubeOptions = generateOptions('tube', 'Tube');

    // Combine all options
    options.push(...tabletOptions);
    options.push(...capsuleOptions);
    options.push(...sachetOptions);
    options.push(...ampouleOptions);
    options.push(...vialOptions);
    options.push(...bottleOptions);
    options.push(...tubeOptions);

    return options;
})(),
    sachet: [
        { value: 'sachet_1', label: '1 Sachet', itemsPerPack: 1, unitOfMeasure: 'sachet' },
        { value: 'sachet_2', label: '2 Sachets', itemsPerPack: 2, unitOfMeasure: 'sachet' },
        { value: 'sachet_3', label: '3 Sachets', itemsPerPack: 3, unitOfMeasure: 'sachet' },
        { value: 'sachet_4', label: '4 Sachets', itemsPerPack: 4, unitOfMeasure: 'sachet' },
        { value: 'sachet_5', label: '5 Sachets', itemsPerPack: 5, unitOfMeasure: 'sachet' },
        { value: 'sachet_6', label: '6 Sachets', itemsPerPack: 6, unitOfMeasure: 'sachet' },
        { value: 'sachet_7', label: '7 Sachets', itemsPerPack: 7, unitOfMeasure: 'sachet' },
        { value: 'sachet_8', label: '8 Sachets', itemsPerPack: 8, unitOfMeasure: 'sachet' },
        { value: 'sachet_9', label: '9 Sachets', itemsPerPack: 9, unitOfMeasure: 'sachet' },
        { value: 'sachet_10', label: '10 Sachets', itemsPerPack: 10, unitOfMeasure: 'sachet' },
        { value: 'sachet_11', label: '11 Sachets', itemsPerPack: 11, unitOfMeasure: 'sachet' },
        { value: 'sachet_12', label: '12 Sachets', itemsPerPack: 12, unitOfMeasure: 'sachet' },
        { value: 'sachet_13', label: '13 Sachets', itemsPerPack: 13, unitOfMeasure: 'sachet' },
        { value: 'sachet_14', label: '14 Sachets', itemsPerPack: 14, unitOfMeasure: 'sachet' },
        { value: 'sachet_15', label: '15 Sachets', itemsPerPack: 15, unitOfMeasure: 'sachet' },
        { value: 'sachet_16', label: '16 Sachets', itemsPerPack: 16, unitOfMeasure: 'sachet' },
        { value: 'sachet_17', label: '17 Sachets', itemsPerPack: 17, unitOfMeasure: 'sachet' },
        { value: 'sachet_18', label: '18 Sachets', itemsPerPack: 18, unitOfMeasure: 'sachet' },
        { value: 'sachet_19', label: '19 Sachets', itemsPerPack: 19, unitOfMeasure: 'sachet' },
        { value: 'sachet_20', label: '20 Sachets', itemsPerPack: 20, unitOfMeasure: 'sachet' },
        { value: 'sachet_21', label: '21 Sachets', itemsPerPack: 21, unitOfMeasure: 'sachet' },
        { value: 'sachet_22', label: '22 Sachets', itemsPerPack: 22, unitOfMeasure: 'sachet' },
        { value: 'sachet_23', label: '23 Sachets', itemsPerPack: 23, unitOfMeasure: 'sachet' },
        { value: 'sachet_24', label: '24 Sachets', itemsPerPack: 24, unitOfMeasure: 'sachet' },
        { value: 'sachet_25', label: '25 Sachets', itemsPerPack: 25, unitOfMeasure: 'sachet' },
        { value: 'sachet_26', label: '26 Sachets', itemsPerPack: 26, unitOfMeasure: 'sachet' },
        { value: 'sachet_27', label: '27 Sachets', itemsPerPack: 27, unitOfMeasure: 'sachet' },
        { value: 'sachet_28', label: '28 Sachets', itemsPerPack: 28, unitOfMeasure: 'sachet' },
        { value: 'sachet_29', label: '29 Sachets', itemsPerPack: 29, unitOfMeasure: 'sachet' },
        { value: 'sachet_30', label: '30 Sachets', itemsPerPack: 30, unitOfMeasure: 'sachet' },
        { value: 'sachet_31', label: '31 Sachets', itemsPerPack: 31, unitOfMeasure: 'sachet' },
        { value: 'sachet_32', label: '32 Sachets', itemsPerPack: 32, unitOfMeasure: 'sachet' },
        { value: 'sachet_33', label: '33 Sachets', itemsPerPack: 33, unitOfMeasure: 'sachet' },
        { value: 'sachet_34', label: '34 Sachets', itemsPerPack: 34, unitOfMeasure: 'sachet' },
        { value: 'sachet_35', label: '35 Sachets', itemsPerPack: 35, unitOfMeasure: 'sachet' },
        { value: 'sachet_36', label: '36 Sachets', itemsPerPack: 36, unitOfMeasure: 'sachet' },
        { value: 'sachet_37', label: '37 Sachets', itemsPerPack: 37, unitOfMeasure: 'sachet' },
        { value: 'sachet_38', label: '38 Sachets', itemsPerPack: 38, unitOfMeasure: 'sachet' },
        { value: 'sachet_39', label: '39 Sachets', itemsPerPack: 39, unitOfMeasure: 'sachet' },
        { value: 'sachet_40', label: '40 Sachets', itemsPerPack: 40, unitOfMeasure: 'sachet' },
        { value: 'sachet_41', label: '41 Sachets', itemsPerPack: 41, unitOfMeasure: 'sachet' },
        { value: 'sachet_42', label: '42 Sachets', itemsPerPack: 42, unitOfMeasure: 'sachet' },
        { value: 'sachet_43', label: '43 Sachets', itemsPerPack: 43, unitOfMeasure: 'sachet' },
        { value: 'sachet_44', label: '44 Sachets', itemsPerPack: 44, unitOfMeasure: 'sachet' },
        { value: 'sachet_45', label: '45 Sachets', itemsPerPack: 45, unitOfMeasure: 'sachet' },
        { value: 'sachet_46', label: '46 Sachets', itemsPerPack: 46, unitOfMeasure: 'sachet' },
        { value: 'sachet_47', label: '47 Sachets', itemsPerPack: 47, unitOfMeasure: 'sachet' },
        { value: 'sachet_48', label: '48 Sachets', itemsPerPack: 48, unitOfMeasure: 'sachet' },
        { value: 'sachet_49', label: '49 Sachets', itemsPerPack: 49, unitOfMeasure: 'sachet' },
        { value: 'sachet_50', label: '50 Sachets', itemsPerPack: 50, unitOfMeasure: 'sachet' },
        { value: 'sachet_60', label: '60 Sachets', itemsPerPack: 60, unitOfMeasure: 'sachet' },
        { value: 'sachet_70', label: '70 Sachets', itemsPerPack: 70, unitOfMeasure: 'sachet' },
        { value: 'sachet_80', label: '80 Sachets', itemsPerPack: 80, unitOfMeasure: 'sachet' },
        { value: 'sachet_90', label: '90 Sachets', itemsPerPack: 90, unitOfMeasure: 'sachet' },
        { value: 'sachet_100', label: '100 Sachets', itemsPerPack: 100, unitOfMeasure: 'sachet' }
    ],
    tube: [
        { value: 'tube_1g', label: '1 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_2g', label: '2 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_3g', label: '3 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_4g', label: '4 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_5g', label: '5 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_10g', label: '10 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_15g', label: '15 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_20g', label: '20 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_25g', label: '25 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_30g', label: '30 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_40g', label: '40 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_50g', label: '50 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_60g', label: '60 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_75g', label: '75 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_100g', label: '100 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_150g', label: '150 g', itemsPerPack: 1, unitOfMeasure: 'tube' },
        { value: 'tube_200g', label: '200 g', itemsPerPack: 1, unitOfMeasure: 'tube' }
    ],
    strip: [
        { value: 'strip_1', label: 'Strip of 1 Tablet', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_2', label: 'Strip of 2 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_3', label: 'Strip of 3 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_4', label: 'Strip of 4 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_5', label: 'Strip of 5 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_6', label: 'Strip of 6 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_7', label: 'Strip of 7 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_8', label: 'Strip of 8 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_9', label: 'Strip of 9 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_10', label: 'Strip of 10 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_11', label: 'Strip of 11 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_12', label: 'Strip of 12 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_13', label: 'Strip of 13 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_14', label: 'Strip of 14 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_15', label: 'Strip of 15 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_16', label: 'Strip of 16 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_17', label: 'Strip of 17 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_18', label: 'Strip of 18 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_19', label: 'Strip of 19 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_20', label: 'Strip of 20 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_21', label: 'Strip of 21 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_22', label: 'Strip of 22 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_23', label: 'Strip of 23 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_24', label: 'Strip of 24 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_25', label: 'Strip of 25 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_26', label: 'Strip of 26 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_27', label: 'Strip of 27 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_28', label: 'Strip of 28 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_29', label: 'Strip of 29 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_30', label: 'Strip of 30 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_31', label: 'Strip of 31 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_32', label: 'Strip of 32 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_33', label: 'Strip of 33 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_34', label: 'Strip of 34 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_35', label: 'Strip of 35 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_36', label: 'Strip of 36 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_37', label: 'Strip of 37 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_38', label: 'Strip of 38 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_39', label: 'Strip of 39 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_40', label: 'Strip of 40 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_41', label: 'Strip of 41 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_42', label: 'Strip of 42 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_43', label: 'Strip of 43 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_44', label: 'Strip of 44 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_45', label: 'Strip of 45 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_46', label: 'Strip of 46 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_47', label: 'Strip of 47 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_48', label: 'Strip of 48 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_49', label: 'Strip of 49 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_50', label: 'Strip of 50 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_60', label: 'Strip of 60 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_70', label: 'Strip of 70 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_80', label: 'Strip of 80 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_90', label: 'Strip of 90 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_100', label: 'Strip of 100 Tablets', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_1', label: 'Strip of 1 Capsule', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_2', label: 'Strip of 2 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_3', label: 'Strip of 3 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_4', label: 'Strip of 4 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_5', label: 'Strip of 5 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_6', label: 'Strip of 6 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_7', label: 'Strip of 7 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_8', label: 'Strip of 8 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_9', label: 'Strip of 9 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_10', label: 'Strip of 10 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_11', label: 'Strip of 11 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_12', label: 'Strip of 12 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_13', label: 'Strip of 13 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_14', label: 'Strip of 14 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_15', label: 'Strip of 15 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_16', label: 'Strip of 16 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_17', label: 'Strip of 17 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_18', label: 'Strip of 18 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_19', label: 'Strip of 19 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_20', label: 'Strip of 20 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_21', label: 'Strip of 21 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_22', label: 'Strip of 22 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_23', label: 'Strip of 23 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_24', label: 'Strip of 24 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_25', label: 'Strip of 25 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_26', label: 'Strip of 26 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_27', label: 'Strip of 27 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_28', label: 'Strip of 28 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_29', label: 'Strip of 29 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_30', label: 'Strip of 30 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_40', label: 'Strip of 40 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_50', label: 'Strip of 50 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_60', label: 'Strip of 60 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_70', label: 'Strip of 70 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_80', label: 'Strip of 80 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_90', label: 'Strip of 90 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' },
        { value: 'strip_capsule_100', label: 'Strip of 100 Capsules', itemsPerPack: 1, unitOfMeasure: 'strip' }
    ]
};

    const unitsOfMeasure = [
        { value: '', label: 'Select Unit of Measure' },
        { value: 'piece', label: 'Unit' },
        { value: 'strip', label: 'Strip' },
        { value: 'bottle', label: 'Bottle' },
        { value: 'ampoule', label: 'Ampoule' },
        { value: 'tube', label: 'Tube' }
    ];

    const categoryOptions = [
        { value: '', label: 'Select Category' },
        { value: 'medicine', label: 'Medicine' },
        { value: 'surgical', label: 'Surgical' },
        { value: 'baby_care', label: 'Baby Care' },
        { value: 'personal_care', label: 'Personal Care' },
        { value: 'veterinary', label: 'Veterinary' },
        { value: 'herbal', label: 'Herbal' },
        { value: 'supplement', label: 'Supplement' },
        { value: 'medical_equipment', label: 'Medical Equipment' },
        { value: 'diagnostic', label: 'Diagnostic' },
        { value: 'first_aid', label: 'First Aid' },
        { value: 'others', label: 'Others' }
    ];

    // ============================================
    // FORM STATE
    // ============================================
    const initialFormData = {
        date: new Date().toISOString().split('T')[0],
        batch_no: '',
        barcode: '',
        product_name: '',
        product_code: '',
        category: '',
        company: '',
        packing_type: '',
        sub_packing_type: '',
        items_per_pack: '',
        unit_of_measure: '',
        unitorstrip: '',
        sell_per_pack: '',
        total_quantity: '',
        quantity_alert: '',
        expiry_date: '',
        sell_price_per_unit: '',
        bquantity: '',
        purchase_type: 'packing',
        themeColor: localStorage.getItem('ourzest_theme') || '#6366f1',
        mrp: '',
        trade_percent: '',
        extra_percent: '',
        bonus_buy: '',
        bonus_free: '',
        effective_cost_price: '',
        effective_discount_percent: '',
        mrp_per_pack_unit: '',
        mrp_per_base_unit: '',
        cost_price_per_pack_unit: '',
        cost_price_per_base_unit: '',
        pack_content_quantity: '',
        pack_content_label: '',
        pack_base_unit_label: '',
        sell_price_per_item_unit: '',
        sell_price_per_base_unit: '',
        bonus_stock_quantity: '',
        actual_stock_quantity: '',
        _selectedItemId: null
    };

    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [translations, setTranslations] = useState({});
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);
    const [availableSubPackings, setAvailableSubPackings] = useState([]);
    const [hasDraft, setHasDraft] = useState(false);
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [currentThemeColor, setCurrentThemeColor] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [showDraftsList, setShowDraftsList] = useState(false);
    const [savedDrafts, setSavedDrafts] = useState([]);

    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [categorySearchTerm, setCategorySearchTerm] = useState('');
    const [showPackingTypeDropdown, setShowPackingTypeDropdown] = useState(false);
    const [packingTypeSearchTerm, setPackingTypeSearchTerm] = useState('');
    const [showSubPackingDropdown, setShowSubPackingDropdown] = useState(false);
    const [subPackingSearchTerm, setSubPackingSearchTerm] = useState('');
    const [showUnitDropdown, setShowUnitDropdown] = useState(false);
    const [unitSearchTerm, setUnitSearchTerm] = useState('');

    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [productSearchResults, setProductSearchResults] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const searchCache = useRef({});

    const categoryDropdownRef = useRef(null);
    const packingTypeDropdownRef = useRef(null);
    const subPackingDropdownRef = useRef(null);
    const unitDropdownRef = useRef(null);
    const draftsDropdownRef = useRef(null);
    const productDropdownRef = useRef(null);

    const [calculatedSellPerPack, setCalculatedSellPerPack] = useState('');
    const [calculatedBQuantity, setCalculatedBQuantity] = useState('');

    const isSubmittingRef = useRef(false);
    const toastTimerRef = useRef(null);
    const lastSubmitTimeRef = useRef(0);
    const lastProductDataRef = useRef('');
    const isInitialLoadRef = useRef(true);
    const isClearingRef = useRef(false);
    const lastDraftContentRef = useRef('');
    const isAutoSavingRef = useRef(false);
    const searchRequestIdRef = useRef(0);
    const calculationTimeoutRef = useRef(null);

    // ============================================
    // EFFECT TO CALCULATE EFFECTIVE COST PRICE, MRP PER UNIT,
    // PACK CONTENT, BONUS-ADJUSTED STOCK QUANTITY & DYNAMIC PER-UNIT PRICES
    // ============================================
    useEffect(() => {
        if (calculationTimeoutRef.current) {
            clearTimeout(calculationTimeoutRef.current);
        }

        calculationTimeoutRef.current = setTimeout(() => {
            const mrp = parseFloat(formData.mrp) || 0;
            const tradePercent = parseFloat(formData.trade_percent) || 0;
            const extraPercent = parseFloat(formData.extra_percent) || 0;
            const bonusBuy = parseInt(formData.bonus_buy) || 0;
            const bonusFree = parseInt(formData.bonus_free) || 0;
            const itemsPerPack = parseFloat(formData.items_per_pack) || 0;
            const unitOfMeasure = formData.unit_of_measure || '';

            let effectiveCostPrice = 0;
            let discountPercent = 0;
            let totalQuantity = 0;
            let perUnitCost = 0;
            let bonusPerUnit = 0;
            let mrpPerPackUnit = 0;
            let mrpPerBaseUnit = 0;

            if (mrp > 0) {
                const result = calculateEffectiveCostPrice(mrp, tradePercent, extraPercent, bonusBuy, bonusFree);
                effectiveCostPrice = result.effectiveCostPrice;
                discountPercent = result.discountPercent;
                totalQuantity = result.totalQuantity;
                perUnitCost = result.perUnitCost;
                bonusPerUnit = result.bonusPerUnit;
                mrpPerPackUnit = result.mrpPerPackUnit;
                mrpPerBaseUnit = result.mrpPerBaseUnit;
            }

            const priceBase = effectiveCostPrice > 0 ? effectiveCostPrice : (parseFloat(formData.sell_per_pack) || 0);

            const { totalBaseUnits, baseUnitLabel } = parseSubPackingBaseUnits(
                subPackingSearchTerm,
                itemsPerPack,
                unitOfMeasure
            );
            const packContentLabel = formatPackContent(totalBaseUnits, baseUnitLabel);

            let mrpPerPackUnitCalc = 0;
            if (mrp > 0 && itemsPerPack > 0) {
                mrpPerPackUnitCalc = mrp / itemsPerPack;
            }

            let mrpPerBaseUnitCalc = 0;
            if (mrp > 0 && totalBaseUnits > 0) {
                mrpPerBaseUnitCalc = mrp / totalBaseUnits;
            }

            let costPricePerPackUnit = 0;
            if (effectiveCostPrice > 0 && itemsPerPack > 0) {
                costPricePerPackUnit = effectiveCostPrice / itemsPerPack;
            }

            let costPricePerBaseUnit = 0;
            if (effectiveCostPrice > 0 && totalBaseUnits > 0) {
                costPricePerBaseUnit = effectiveCostPrice / totalBaseUnits;
            }

            const { bonusStockQuantity, actualStockQuantity } = calculateBonusStock(
                formData.total_quantity,
                formData.bonus_buy,
                formData.bonus_free
            );

            setFormData(prev => ({
                ...prev,
                effective_cost_price: effectiveCostPrice > 0 ? effectiveCostPrice.toFixed(2) : '',
                effective_discount_percent: discountPercent > 0 ? discountPercent.toFixed(2) : '',
                sell_per_pack: effectiveCostPrice > 0 ? effectiveCostPrice.toFixed(2) : prev.sell_per_pack,
                mrp_per_pack_unit: mrpPerPackUnitCalc > 0 ? mrpPerPackUnitCalc.toFixed(4) : '',
                mrp_per_base_unit: mrpPerBaseUnitCalc > 0 ? mrpPerBaseUnitCalc.toFixed(4) : '',
                cost_price_per_pack_unit: costPricePerPackUnit > 0 ? costPricePerPackUnit.toFixed(4) : '',
                cost_price_per_base_unit: costPricePerBaseUnit > 0 ? costPricePerBaseUnit.toFixed(4) : '',
                pack_content_quantity: totalBaseUnits > 0 ? totalBaseUnits.toString() : '',
                pack_content_label: packContentLabel,
                pack_base_unit_label: baseUnitLabel || '',
                sell_price_per_item_unit: costPricePerPackUnit > 0 ? costPricePerPackUnit.toFixed(4) : '',
                sell_price_per_base_unit: costPricePerBaseUnit > 0 ? costPricePerBaseUnit.toFixed(4) : '',
                bonus_stock_quantity: bonusStockQuantity > 0 ? formatQuantityValue(bonusStockQuantity) : '',
                actual_stock_quantity: actualStockQuantity > 0 ? formatQuantityValue(actualStockQuantity) : ''
            }));
        }, 100);

        return () => {
            if (calculationTimeoutRef.current) {
                clearTimeout(calculationTimeoutRef.current);
            }
        };
    }, [
        formData.mrp,
        formData.trade_percent,
        formData.extra_percent,
        formData.bonus_buy,
        formData.bonus_free,
        formData.items_per_pack,
        formData.unit_of_measure,
        formData.sell_per_pack,
        formData.total_quantity,
        subPackingSearchTerm
    ]);

    // ============================================
    // PRODUCT SEARCH FUNCTIONS
    // ============================================
    const searchProducts = async (searchTerm) => {
        if (!searchTerm || searchTerm.trim().length < 1) {
            setProductSearchResults([]);
            setShowProductDropdown(false);
            return;
        }

        const cacheKey = searchTerm.trim().toLowerCase();
        if (searchCache.current[cacheKey]) {
            setProductSearchResults(searchCache.current[cacheKey]);
            setShowProductDropdown(true);
            return;
        }

        const requestId = ++searchRequestIdRef.current;

        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'search',
                    search: searchTerm.trim()
                })
            });

            if (!response.ok) {
                if (requestId === searchRequestIdRef.current) {
                    setProductSearchResults([]);
                    setShowProductDropdown(true);
                }
                return;
            }

            const data = await response.json();

            if (requestId !== searchRequestIdRef.current) return;

            if (data.status === 'success') {
                const mappedResults = (data.data || []).map(item => ({
                    id: item.id,
                    product_name: item.itemname || '',
                    _original: item
                }));
                
                searchCache.current[cacheKey] = mappedResults;
                setProductSearchResults(mappedResults);
                setShowProductDropdown(true);
            } else {
                setProductSearchResults([]);
                setShowProductDropdown(true);
            }
        } catch (error) {
            if (requestId === searchRequestIdRef.current) {
                setProductSearchResults([]);
                setShowProductDropdown(true);
            }
        }
    };

    // ============================================
    // HANDLE PRODUCT SELECT
    // ============================================
    const handleProductSelect = (product) => {
        setSelectedProduct(product);
        setProductSearchTerm(product.product_name);
        setShowProductDropdown(false);
        setTimeout(() => {
            if (batchNoRef.current) {
                batchNoRef.current.focus();
            }
        }, 50);

        setFormData(prev => ({
            ...prev,
            product_name: product.product_name,
            product_code: product.product_code || '',
            company: product.company || '',
            category: product.category || '',
            _selectedItemId: product.id || null
        }));

        const catOption = categoryOptions.find(c => c.value === product.category);
        setCategorySearchTerm(catOption ? catOption.label : (product.category || ''));

        showToast('success', `Selected: ${product.product_name}`);
    };

    // ============================================
    // EFFECTS
    // ============================================

    useEffect(() => {
        setTimeout(() => {
            if (productNameRef.current) {
                productNameRef.current.focus();
            }
        }, 100);
    }, []);

    useEffect(() => {
        const handleTabKey = (e) => {
            if (e.key === 'Tab') {
                setShowCategoryDropdown(false);
                setShowPackingTypeDropdown(false);
                setShowSubPackingDropdown(false);
                setShowUnitDropdown(false);
                setShowProductDropdown(false);
            }
        };
        document.addEventListener('keydown', handleTabKey);
        return () => document.removeEventListener('keydown', handleTabKey);
    }, []);

    useEffect(() => {
        if (formData.packing_type && subPackingTypesMap[formData.packing_type]) {
            setAvailableSubPackings(subPackingTypesMap[formData.packing_type]);
            if (formData.sub_packing_type) {
                setFormData(prev => ({ ...prev, sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                setSubPackingSearchTerm('');
                setUnitSearchTerm('');
            }
        } else {
            setAvailableSubPackings([]);
        }
    }, [formData.packing_type]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (productSearchTerm && productSearchTerm.length >= 1) {
                searchProducts(productSearchTerm);
            } else {
                setProductSearchResults([]);
                setShowProductDropdown(false);
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [productSearchTerm]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (productDropdownRef.current && !productDropdownRef.current.contains(event.target)) {
                setShowProductDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        return () => {
            searchCache.current = {};
        };
    }, []);

    // ============================================
    // HANDLE SUB PACKING CHANGE
    // ============================================
    const handleSubPackingChange = (subPackingValue, subPackingLabel) => {
        const selectedSubPacking = availableSubPackings.find(sp => sp.value === subPackingValue);
        if (selectedSubPacking) {
            let defaultItemsPerPack = selectedSubPacking.itemsPerPack || 1;
            let defaultUnitOfMeasure = selectedSubPacking.unitOfMeasure || 'piece';

            setFormData(prev => ({
                ...prev,
                sub_packing_type: subPackingValue,
                items_per_pack: defaultItemsPerPack.toString(),
                unit_of_measure: defaultUnitOfMeasure,
                // Auto-calculate unitorstrip when sub packing changes
                unitorstrip: determineUnitOrStrip(
                    prev.packing_type,
                    subPackingValue,
                    defaultUnitOfMeasure
                )
            }));
            setSubPackingSearchTerm(subPackingLabel);

            const selectedUnit = unitsOfMeasure.find(u => u.value === defaultUnitOfMeasure);
            if (selectedUnit) {
                setUnitSearchTerm(selectedUnit.label);
            }
        } else {
            setFormData(prev => ({
                ...prev,
                sub_packing_type: subPackingValue,
                items_per_pack: '',
                unit_of_measure: '',
                unitorstrip: determineUnitOrStrip(prev.packing_type, subPackingValue, '')
            }));
            setSubPackingSearchTerm(subPackingLabel);
        }
        setShowSubPackingDropdown(false);
    };

    // ============================================
    // CALCULATE DERIVED FIELDS
    // ============================================
    useEffect(() => {
        let newSellPricePerUnit = '';
        let newBQuantity = '';

        if (formData.sell_per_pack && formData.items_per_pack) {
            const sellPerPack = parseFloat(formData.sell_per_pack);
            const itemsPerPack = parseFloat(formData.items_per_pack);
            if (sellPerPack > 0 && itemsPerPack > 0) {
                const sellPricePerUnit = sellPerPack / itemsPerPack;
                newSellPricePerUnit = sellPricePerUnit.toFixed(4);
                setCalculatedSellPerPack(newSellPricePerUnit);
            }
        } else {
            setCalculatedSellPerPack('');
        }

        const bqSourceQuantity = formData.actual_stock_quantity || formData.total_quantity;

        if (formData.items_per_pack && formData.unit_of_measure && bqSourceQuantity) {
            newBQuantity = calculateBQuantity(
                parseFloat(formData.items_per_pack),
                formData.unit_of_measure,
                parseFloat(bqSourceQuantity)
            );
            setCalculatedBQuantity(newBQuantity);
        } else {
            setCalculatedBQuantity('');
        }

        setFormData(prev => ({
            ...prev,
            sell_price_per_unit: newSellPricePerUnit,
            bquantity: newBQuantity
        }));

    }, [formData.sell_per_pack, formData.items_per_pack, formData.unit_of_measure, formData.total_quantity, formData.actual_stock_quantity]);

    // ============================================
    // DRAFT MANAGEMENT
    // ============================================
    const getDraftStorageKey = () => {
        const userId = user?.user_id || user?.username || 'anonymous';
        const shopId = currentShop?.shop_id || 'no_shop';
        return `product_draft_${userId}_${shopId}`;
    };

    const getCurrentFormContent = () => {
        return JSON.stringify({
            product_name: formData.product_name || '',
            batch_no: formData.batch_no || '',
            product_code: formData.product_code || '',
            company: formData.company || '',
            packing_type: formData.packing_type || '',
            sub_packing_type: formData.sub_packing_type || '',
            items_per_pack: formData.items_per_pack || '',
            unit_of_measure: formData.unit_of_measure || '',
            unitorstrip: formData.unitorstrip || '',
            sell_per_pack: formData.sell_per_pack || '',
            total_quantity: formData.total_quantity || '',
            quantity_alert: formData.quantity_alert || '',
            mrp: formData.mrp || '',
            trade_percent: formData.trade_percent || '',
            extra_percent: formData.extra_percent || '',
            bonus_buy: formData.bonus_buy || '',
            bonus_free: formData.bonus_free || ''
        });
    };

    const saveDraft = () => {
        if (isEditMode || isClearingRef.current) {
            if (isEditMode) showToast('warning', 'Cannot save draft in edit mode');
            return false;
        }

        const hasData = formData.product_name?.trim() ||
            formData.batch_no?.trim() ||
            formData.product_code?.trim() ||
            formData.company?.trim() ||
            formData.packing_type ||
            formData.sell_per_pack ||
            formData.mrp;

        if (!hasData) {
            showToast('warning', 'Cannot save empty draft. Please enter at least one field.');
            return false;
        }

        const currentContent = getCurrentFormContent();
        if (currentContent === lastDraftContentRef.current) {
            showToast('info', 'No changes to save');
            return false;
        }

        lastDraftContentRef.current = currentContent;

        const draftId = Date.now();
        const draft = {
            id: draftId,
            ...formData,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };

        const existingDrafts = JSON.parse(localStorage.getItem('product_drafts') || '[]');
        const filteredDrafts = existingDrafts.filter(d =>
            !(d.product_name === formData.product_name &&
                d.batch_no === formData.batch_no &&
                d.shop_id === currentShop?.shop_id)
        );
        filteredDrafts.unshift(draft);
        const limitedDrafts = filteredDrafts.slice(0, 20);
        localStorage.setItem('product_drafts', JSON.stringify(limitedDrafts));
        loadDrafts();
        showToast('success', 'Draft saved successfully!');
        return true;
    };

    const loadDrafts = () => {
        const drafts = JSON.parse(localStorage.getItem('product_drafts') || '[]');
        const filteredDrafts = currentShop ? drafts.filter(d => d.shop_id === currentShop?.shop_id) : drafts;
        setSavedDrafts(filteredDrafts);
        setHasDraft(filteredDrafts.length > 0);
    };

    const loadDraft = (draft) => {
        setFormData({
            date: draft.date || new Date().toISOString().split('T')[0],
            batch_no: draft.batch_no || '',
            barcode: draft.barcode || '',
            product_name: draft.product_name || '',
            product_code: draft.product_code || '',
            category: draft.category || '',
            company: draft.company || '',
            packing_type: draft.packing_type || '',
            sub_packing_type: draft.sub_packing_type || '',
            items_per_pack: draft.items_per_pack || '',
            unit_of_measure: draft.unit_of_measure || '',
            unitorstrip: draft.unitorstrip || '',
            sell_per_pack: draft.sell_per_pack || '',
            total_quantity: draft.total_quantity || '',
            quantity_alert: draft.quantity_alert || '',
            expiry_date: draft.expiry_date || '',
            sell_price_per_unit: draft.sell_price_per_unit || '',
            bquantity: draft.bquantity || '',
            purchase_type: draft.purchase_type || 'packing',
            themeColor: formData.themeColor,
            mrp: draft.mrp || '',
            trade_percent: draft.trade_percent || '',
            extra_percent: draft.extra_percent || '',
            bonus_buy: draft.bonus_buy || '',
            bonus_free: draft.bonus_free || '',
            effective_cost_price: draft.effective_cost_price || '',
            effective_discount_percent: draft.effective_discount_percent || '',
            mrp_per_pack_unit: draft.mrp_per_pack_unit || '',
            mrp_per_base_unit: draft.mrp_per_base_unit || '',
            cost_price_per_pack_unit: draft.cost_price_per_pack_unit || '',
            cost_price_per_base_unit: draft.cost_price_per_base_unit || '',
            pack_content_quantity: draft.pack_content_quantity || '',
            pack_content_label: draft.pack_content_label || '',
            pack_base_unit_label: draft.pack_base_unit_label || '',
            sell_price_per_item_unit: draft.sell_price_per_item_unit || '',
            sell_price_per_base_unit: draft.sell_price_per_base_unit || '',
            bonus_stock_quantity: draft.bonus_stock_quantity || '',
            actual_stock_quantity: draft.actual_stock_quantity || '',
            _selectedItemId: draft._selectedItemId || null
        });

        const selectedCategory = categoryOptions.find(c => c.value === draft.category);
        setCategorySearchTerm(selectedCategory ? selectedCategory.label : '');
        const selectedPackingType = packingTypes.find(p => p.value === draft.packing_type);
        setPackingTypeSearchTerm(selectedPackingType ? selectedPackingType.label : '');
        const selectedSubPacking = availableSubPackings.find(s => s.value === draft.sub_packing_type);
        setSubPackingSearchTerm(selectedSubPacking ? selectedSubPacking.label : '');
        const selectedUnit = unitsOfMeasure.find(u => u.value === draft.unit_of_measure);
        setUnitSearchTerm(selectedUnit ? selectedUnit.label : '');

        setProductSearchTerm(draft.product_name || '');

        lastDraftContentRef.current = getCurrentFormContent();
        setShowDraftsList(false);
        showToast('success', translations.draftLoaded || 'Draft loaded successfully!');

        setTimeout(() => {
            if (productNameRef.current) {
                productNameRef.current.focus();
            }
        }, 100);
    };

    const deleteDraft = (draftId) => {
        const drafts = JSON.parse(localStorage.getItem('product_drafts') || '[]');
        const filteredDrafts = drafts.filter(d => d.id !== draftId);
        localStorage.setItem('product_drafts', JSON.stringify(filteredDrafts));
        loadDrafts();
        showToast('success', 'Draft deleted successfully!');
        if (filteredDrafts.length === 0) {
            lastDraftContentRef.current = '';
        }
    };

    useEffect(() => {
        loadDrafts();
    }, [currentShop]);

    useEffect(() => {
        if (isEditMode || isClearingRef.current || isSubmittingRef.current) return;
        if (isInitialLoadRef.current) return;

        const timer = setTimeout(() => {
            if (!isAutoSavingRef.current) {
                isAutoSavingRef.current = true;
                saveDraft();
                isAutoSavingRef.current = false;
            }
        }, 3000);

        return () => clearTimeout(timer);
    }, [
        formData.product_name,
        formData.batch_no,
        formData.product_code,
        formData.company,
        formData.packing_type,
        formData.sub_packing_type,
        formData.items_per_pack,
        formData.unit_of_measure,
        formData.sell_per_pack,
        formData.total_quantity,
        formData.quantity_alert,
        formData.mrp,
        formData.trade_percent,
        formData.extra_percent,
        formData.bonus_buy,
        formData.bonus_free,
        isEditMode
    ]);

    // ============================================
    // TOAST FUNCTION
    // ============================================
    const showToast = (type, message) => {
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        setToast({ show: true, type, message });
        toastTimerRef.current = setTimeout(() => {
            setToast({ show: false, type: '', message: '' });
        }, 3000);
    };

    // ============================================
    // LANGUAGE, THEME, DARK MODE SYNC
    // ============================================
    useEffect(() => {
        if (user?.language && user.language !== currentLanguage) {
            setCurrentLanguage(user.language);
        }
    }, [user?.language]);

    useEffect(() => {
        const loadTranslations = async () => {
            const trans = await productsTranslator.getTranslations(currentLanguage);
            setTranslations(trans);
        };
        loadTranslations();
    }, [currentLanguage]);

    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
            color = '#6366f1';
        }

        document.documentElement.style.setProperty('--pharmacy-primary', color);
        document.documentElement.style.setProperty('--pharmacy-primary-dark', color);
        document.documentElement.style.setProperty('--pharmacy-primary-light', color);

        let r, g, b;
        if (color.startsWith('#')) {
            r = parseInt(color.slice(1, 3), 16);
            g = parseInt(color.slice(3, 5), 16);
            b = parseInt(color.slice(5, 7), 16);
        } else {
            r = 99; g = 102; b = 241;
        }

        const orbs = document.querySelectorAll('.pharmacy-header-bg-animation .gradient-orb');
        if (orbs.length > 0) {
            const orbColors = [
                `rgba(${r}, ${g}, ${b}, 0.4)`,
                `rgba(${r}, ${g}, ${b}, 0.35)`,
                `rgba(${r}, ${g}, ${b}, 0.3)`,
                `rgba(${r}, ${g}, ${b}, 0.25)`,
                `rgba(${r}, ${g}, ${b}, 0.2)`
            ];

            orbs.forEach((orb, index) => {
                const color1 = orbColors[index] || orbColors[0];
                const color2 = orbColors[index] ? `rgba(${r}, ${g}, ${b}, 0.05)` : `rgba(${r}, ${g}, ${b}, 0.02)`;
                orb.style.background = `radial-gradient(circle, ${color1} 0%, ${color2} 100%)`;
            });
        }

        const style = document.createElement('style');
        style.id = 'pharmacy-theme-styles';
        style.textContent = `
            .pharmacy-btn-primary {
                background: ${color} !important;
            }
            .pharmacy-btn-primary:hover:not(:disabled) {
                background: ${color} !important;
                filter: brightness(0.9);
            }
            .pharmacy-input-wrapper input:focus ~ label,
            .pharmacy-input-wrapper select:focus ~ label {
                color: ${color} !important;
            }
            .pharmacy-input-wrapper input:focus,
            .pharmacy-input-wrapper select:focus {
                border-color: ${color} !important;
            }
            .pharmacy-category-option.pharmacy-selected {
                background: ${color}22 !important;
                color: ${color} !important;
            }
            .pharmacy_shop-item.pharmacy_active {
                border-color: ${color} !important;
                background: ${color}11 !important;
            }
            .pharmacy_shop-badge {
                color: ${color} !important;
            }
            .pharmacy-action-btn.save-draft {
                color: ${color} !important;
            }
            .pharmacy-action-btn.save-draft:hover {
                background: ${color}11 !important;
            }
            .pharmacy-per-unit-price {
                color: ${color} !important;
            }
        `;

        const oldStyle = document.getElementById('pharmacy-theme-styles');
        if (oldStyle) {
            oldStyle.remove();
        }
        document.head.appendChild(style);

        setCurrentThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                applyTheme(e.newValue || '#6366f1');
            }
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        const checkThemeInterval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentThemeColor) {
                applyTheme(storedTheme);
            }
        }, 500);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(checkThemeInterval);
            const style = document.getElementById('pharmacy-theme-styles');
            if (style) style.remove();
        };
    }, [applyTheme, currentThemeColor]);

    useEffect(() => {
        const syncDarkMode = () => {
            const isDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDarkMode);

            const container = document.querySelector('.pharmacy-container');
            if (container) {
                if (isDarkMode) {
                    container.classList.add('pharmacy-dark');
                } else {
                    container.classList.remove('pharmacy-dark');
                }
            }

            if (isDarkMode) {
                document.body.classList.add('pharmacy-dark');
                document.documentElement.classList.add('pharmacy-dark');
            } else {
                document.body.classList.remove('pharmacy-dark');
                document.documentElement.classList.remove('pharmacy-dark');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);

                const container = document.querySelector('.pharmacy-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('pharmacy-dark');
                    } else {
                        container.classList.remove('pharmacy-dark');
                    }
                }

                if (isDark) {
                    document.body.classList.add('pharmacy-dark');
                    document.documentElement.classList.add('pharmacy-dark');
                } else {
                    document.body.classList.remove('pharmacy-dark');
                    document.documentElement.classList.remove('pharmacy-dark');
                }
            } else {
                syncDarkMode();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
        };
    }, []);

    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.pharmacy-container');
        if (container) {
            if (isRTL) {
                container.classList.add('pharmacy-rtl');
                container.classList.remove('pharmacy-ltr');
            } else {
                container.classList.add('pharmacy-ltr');
                container.classList.remove('pharmacy-rtl');
            }
        }
        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    // ============================================
    // HANDLE INPUT CHANGE
    // ============================================
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'items_per_pack' || name === 'total_quantity' || name === 'sell_per_pack') {
            setFormData(prev => ({ ...prev, [name]: value }));
        } else if (name === 'product_name') {
            setFormData(prev => ({ ...prev, [name]: value }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    // ============================================
    // DROPDOWN SELECT HANDLERS
    // ============================================
    const selectCategory = (category) => {
        setFormData(prev => ({ ...prev, category: category.value }));
        setCategorySearchTerm(category.label);
        setShowCategoryDropdown(false);
    };

    const selectPackingType = (packingType) => {
        setFormData(prev => ({ 
            ...prev, 
            packing_type: packingType.value, 
            sub_packing_type: '', 
            items_per_pack: '', 
            unit_of_measure: '',
            unitorstrip: determineUnitOrStrip(packingType.value, '', '')
        }));
        setPackingTypeSearchTerm(packingType.label);
        setSubPackingSearchTerm('');
        setUnitSearchTerm('');
        setShowPackingTypeDropdown(false);
    };

    const selectUnit = (unit) => {
        setFormData(prev => ({ 
            ...prev, 
            unit_of_measure: unit.value,
            unitorstrip: determineUnitOrStrip(prev.packing_type, prev.sub_packing_type, unit.value)
        }));
        setUnitSearchTerm(unit.label);
        setShowUnitDropdown(false);
    };

    // ============================================
    // FILTERED OPTIONS FOR DROPDOWNS
    // ============================================
    const filteredCategories = categorySearchTerm.trim() === ''
        ? categoryOptions
        : categoryOptions.filter(cat =>
            cat.label.toLowerCase().includes(categorySearchTerm.toLowerCase())
        );

    const filteredPackingTypes = packingTypeSearchTerm.trim() === ''
        ? packingTypes.filter(pt => pt.value !== '')
        : packingTypes.filter(pt =>
            pt.value !== '' && pt.label.toLowerCase().includes(packingTypeSearchTerm.toLowerCase())
        );

    const filteredSubPackings = subPackingSearchTerm.trim() === ''
        ? availableSubPackings
        : availableSubPackings.filter(sub =>
            sub.label.toLowerCase().includes(subPackingSearchTerm.toLowerCase())
        );

    const filteredUnits = unitSearchTerm.trim() === ''
        ? unitsOfMeasure.filter(u => u.value !== '')
        : unitsOfMeasure.filter(u =>
            u.value !== '' && u.label.toLowerCase().includes(unitSearchTerm.toLowerCase())
        );

    // ============================================
    // CLICK OUTSIDE HANDLERS
    // ============================================
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
                setShowCategoryDropdown(false);
            }
            if (packingTypeDropdownRef.current && !packingTypeDropdownRef.current.contains(event.target)) {
                setShowPackingTypeDropdown(false);
            }
            if (subPackingDropdownRef.current && !subPackingDropdownRef.current.contains(event.target)) {
                setShowSubPackingDropdown(false);
            }
            if (unitDropdownRef.current && !unitDropdownRef.current.contains(event.target)) {
                setShowUnitDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // ============================================
    // VALIDATION
    // ============================================
    const validateForm = () => {
        const newErrors = {};

        if (!formData.product_name?.trim()) {
            newErrors.product_name = translations.nameRequired || 'Product name is required';
        } else if (formData.product_name.trim().length < 2) {
            newErrors.product_name = translations.nameTooShort || 'Name must be at least 2 characters';
        }

        if (!formData.batch_no?.trim()) {
            newErrors.batch_no = translations.batchRequired || 'Batch number is required';
        }

        if (!formData.packing_type) {
            newErrors.packing_type = 'Packing type is required';
        }

        if (!formData.sub_packing_type) {
            newErrors.sub_packing_type = 'Sub packing type is required';
        }

        if (!formData.items_per_pack || parseFloat(formData.items_per_pack) <= 0) {
            newErrors.items_per_pack = 'Units per pack is required';
        }

        if (!formData.unit_of_measure) {
            newErrors.unit_of_measure = 'Unit of measure is required';
        }

        if (!formData.sell_per_pack || parseFloat(formData.sell_per_pack) <= 0) {
            newErrors.sell_per_pack = 'Retail price per pack is required';
        }

        if (!formData.total_quantity || parseFloat(formData.total_quantity) < 0) {
            newErrors.total_quantity = translations.quantityRequired || 'Quantity is required';
        }

        if (!formData.quantity_alert || parseFloat(formData.quantity_alert) < 0) {
            newErrors.quantity_alert = translations.alertRequired || 'Low stock alert quantity is required';
        }

        if (formData.expiry_date) {
            const expiry = new Date(formData.expiry_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (expiry < today) {
                newErrors.expiry_date = translations.expiryPast || 'Expiry date cannot be in the past';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ============================================
    // SUBMIT HANDLER
    // ============================================
    // ============================================
// SUBMIT HANDLER - WITH BETTER LOGGING & FIXES
// ============================================
const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!currentShop) {
        showToast('error', translations.selectShop || 'Please select a shop first');
        setShowShopSelector(true);
        return;
    }

    if (!validateForm()) return;

    if (isSubmittingRef.current) {
        showToast('warning', 'Please wait, submission in progress...');
        return;
    }

    const now = Date.now();
    if (now - lastSubmitTimeRef.current < 3000) {
        showToast('warning', 'Please wait before submitting again');
        return;
    }

    const currentProductData = JSON.stringify({
        product_name: formData.product_name,
        batch_no: formData.batch_no,
        product_code: formData.product_code,
        shop_id: currentShop.shop_id,
        total_quantity: formData.total_quantity
    });

    if (!isEditMode && currentProductData === lastProductDataRef.current) {
        showToast('warning', 'This product appears to be a duplicate. Please check.');
        return;
    }

    lastProductDataRef.current = currentProductData;
    lastSubmitTimeRef.current = now;

    isSubmittingRef.current = true;
    setLoading(true);

    const submitButton = document.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    try {
        const currentUsername = user?.username || 'Unknown';
        const itemsPerPack = parseFloat(formData.items_per_pack) || 1;

        const purchasedQuantity = formData.total_quantity;
        const actualStockQuantity = formData.actual_stock_quantity || formData.total_quantity;

        // ============================================
        // DETERMINE UNITORSTRIP VALUE
        // ============================================
        let unitorstripValue = determineUnitOrStrip(
            formData.packing_type,
            formData.sub_packing_type,
            formData.unit_of_measure
        );

        // ============================================
        // STEP 1: Check if product exists in items table
        // ============================================
        let itemSaved = false;
        let existingItemId = formData._selectedItemId;
        
        console.log('🔍 Starting product save process...');
        console.log('Product name:', formData.product_name);
        console.log('Existing item ID:', existingItemId);
        
        // Determine itemtype from sub_packing_type or packing_type
        let itemType = formData.sub_packing_type || formData.packing_type || '';
        
        // Map common types
        const typeMap = {
            'capsule': 'Capsule',
            'tablet': 'Tablet',
            'injection': 'Injection',
            'vial': 'Injection',
            'ampoule': 'Injection',
            'syrup': 'Syrup',
            'suspension': 'Syrup',
            'ointment': 'Ointment',
            'cream': 'Cream',
            'gel': 'Gel',
            'drop': 'Drops',
            'eye_drops': 'Drops',
            'ear_drops': 'Drops',
            'inhaler': 'Inhaler',
            'spray': 'Spray',
            'patch': 'Patch',
            'suppository': 'Suppository',
            'strip': 'Tablet',
            'softgel': 'Capsule',
            'chewable_tablet': 'Tablet',
            'dispersible_tablet': 'Tablet',
            'effervescent_tablet': 'Tablet',
            'sublingual_tablet': 'Tablet',
            'buccal_tablet': 'Tablet'
        };
        
        // Check if itemType contains any of the type keywords
        let mappedType = '';
        const typeLower = itemType.toLowerCase();
        for (const [key, value] of Object.entries(typeMap)) {
            if (typeLower.includes(key)) {
                mappedType = value;
                break;
            }
        }
        if (!mappedType && itemType) {
            mappedType = itemType.charAt(0).toUpperCase() + itemType.slice(1);
        }
        
        console.log('📝 Mapped item type:', mappedType);

        // If we don't have an existing item ID, check if the product exists in the items table
        if (!existingItemId && formData.product_name?.trim()) {
            try {
                console.log('🔎 Searching for existing item:', formData.product_name.trim());
                
                // Search for the product in items table by name
                const searchResponse = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        action: 'search',
                        search: formData.product_name.trim()
                    })
                });
                
                const searchData = await searchResponse.json();
                console.log('📊 Search response:', searchData);
                
                if (searchData.status === 'success' && searchData.data && searchData.data.length > 0) {
                    console.log(`✅ Found ${searchData.data.length} matching items`);
                    // Check if any result matches the product name exactly
                    for (const item of searchData.data) {
                        console.log(`Comparing: "${item.itemname}" with "${formData.product_name.trim()}"`);
                        if (item.itemname.toLowerCase() === formData.product_name.trim().toLowerCase()) {
                            existingItemId = item.id;
                            itemSaved = true;
                            console.log('✅ Product already exists in items table with ID:', existingItemId);
                            break;
                        }
                    }
                    // If not found by exact match, try to find by manufacturer too
                    if (!existingItemId && formData.company?.trim()) {
                        for (const item of searchData.data) {
                            if (item.itemname.toLowerCase() === formData.product_name.trim().toLowerCase() &&
                                item.manufacturer && item.manufacturer.toLowerCase() === formData.company.trim().toLowerCase()) {
                                existingItemId = item.id;
                                itemSaved = true;
                                console.log('✅ Product found by name + manufacturer with ID:', existingItemId);
                                break;
                            }
                        }
                    }
                } else {
                    console.log('❌ No matching items found in search');
                }
            } catch (checkError) {
                console.error('❌ Error checking existing item:', checkError);
            }
        } else if (existingItemId) {
            itemSaved = true;
            console.log('✅ Using existing item ID from form state:', existingItemId);
        }

        // ============================================
        // STEP 2: Only add to items table if it doesn't exist
        // ============================================
        if (!existingItemId && formData.product_name?.trim()) {
            console.log('➕ Adding new item to items table...');
            
            let productCode = formData.product_code?.trim();
            if (!productCode) {
                const namePrefix = formData.product_name.substring(0, 3).toUpperCase();
                productCode = namePrefix + Date.now().toString().slice(-6);
                console.log('📝 Generated product code:', productCode);
            }
            
            try {
                const itemResponse = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        action: 'add',
                        itemcode: productCode,
                        itemname: formData.product_name.trim(),
                        manufacturer: formData.company?.trim() || null,
                        category: formData.category || null,
                        itemtype: mappedType || null
                    })
                });
                
                const itemData = await itemResponse.json();
                console.log('📊 Item add response:', itemData);
                
                if (itemData.status === 'success') {
                    itemSaved = true;
                    existingItemId = itemData.itemid;
                    console.log('✅ Item saved to items table with ID:', existingItemId);
                } else if (itemData.status === 'duplicate') {
                    itemSaved = true;
                    console.log('⚠️ Item already exists in items table (duplicate response)');
                    // Try to get the existing ID from the response
                    if (itemData.existing_id) {
                        existingItemId = itemData.existing_id;
                    } else {
                        // Try to search again to get the ID
                        try {
                            console.log('🔎 Searching again to get existing ID...');
                            const searchAgain = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_items.php', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    action: 'search',
                                    search: formData.product_name.trim()
                                })
                            });
                            const searchAgainData = await searchAgain.json();
                            console.log('📊 Search again response:', searchAgainData);
                            if (searchAgainData.status === 'success' && searchAgainData.data) {
                                for (const item of searchAgainData.data) {
                                    if (item.itemname.toLowerCase() === formData.product_name.trim().toLowerCase()) {
                                        existingItemId = item.id;
                                        console.log('✅ Found existing item ID:', existingItemId);
                                        break;
                                    }
                                }
                            }
                        } catch (searchError) {
                            console.warn('❌ Could not retrieve existing item ID:', searchError);
                        }
                    }
                } else {
                    console.error('❌ Failed to save item to items table:', itemData.message);
                    // Continue anyway - we'll still save the product
                }
            } catch (itemError) {
                console.error('❌ Error saving to items table:', itemError);
                // Continue anyway - we'll still save the product
            }
        }

        // ============================================
        // STEP 3: Save to pharmacy_products table
        // ============================================
        console.log('💾 Saving product to pharmacy_products...');
        
        const productData = {
            action: isEditMode ? 'edit' : 'add',
            product_name: formData.product_name,
            product_code: formData.product_code,
            batch_no: formData.batch_no || '',
            category: formData.category || '',
            company: formData.company || '',
            date: formData.date,
            expiry_date: formData.expiry_date || null,
            quantity_alert: formData.quantity_alert,
            total_quantity: actualStockQuantity,
            purchased_quantity: purchasedQuantity,
            bonus_stock_quantity: formData.bonus_stock_quantity || 0,
            packing_type: formData.packing_type,
            sub_packing_type: formData.sub_packing_type,
            items_per_pack: itemsPerPack,
            unit_of_measure: formData.unit_of_measure,
            unitorstrip: unitorstripValue,
            sell_per_pack: formData.sell_per_pack,
            purchase_type: 'packing',
            username: currentUsername,
            shop_id: currentShop.shop_id,
            mrp: formData.mrp || null,
            trade_percent: formData.trade_percent || null,
            extra_percent: formData.extra_percent || null,
            bonus_buy: formData.bonus_buy || null,
            bonus_free: formData.bonus_free || null,
            effective_cost_price: formData.effective_cost_price || null,
            effective_discount_percent: formData.effective_discount_percent || null,
            mrp_per_pack_unit: formData.mrp_per_pack_unit || null,
            mrp_per_base_unit: formData.mrp_per_base_unit || null,
            cost_price_per_pack_unit: formData.cost_price_per_pack_unit || null,
            cost_price_per_base_unit: formData.cost_price_per_base_unit || null,
            pack_content_quantity: formData.pack_content_quantity || null,
            pack_content_label: formData.pack_content_label || null,
            pack_base_unit_label: formData.pack_base_unit_label || null,
            sell_price_per_item_unit: formData.sell_price_per_item_unit || null,
            sell_price_per_base_unit: formData.sell_price_per_base_unit || null,
            _timestamp: Date.now()
        };

        if (isEditMode && productId) {
            productData.id = productId;
        }

        console.log('📤 Sending product data:', JSON.stringify(productData, null, 2));

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);

        const response = await fetch('https://ourzestapp.online/oz_backend/pharmacy_module/pharmacy_products.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(productData),
            signal: controller.signal
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
            const errorText = await response.text();
            console.error('❌ Server error response:', errorText);
            throw new Error(`Server responded with status ${response.status}: ${errorText.substring(0, 200)}`);
        }

        const responseText = await response.text();
        console.log('📥 Raw response:', responseText);

        if (!responseText || responseText.trim() === '') {
            throw new Error('Empty response from server');
        }

        let data;
        try {
            data = JSON.parse(responseText);
        } catch (jsonError) {
            console.error('❌ JSON Parse Error. Raw response:', responseText.substring(0, 500));
            throw new Error('Invalid JSON response from server.');
        }

        console.log('📊 Parsed response:', data);

        if (data.status === 'duplicate' || data.duplicate_prevention) {
            showToast('warning', data.message || 'Duplicate submission prevented. Please wait.');
            lastProductDataRef.current = '';
            return;
        }

        if (data.status === 'success') {
            let successMessage = isEditMode
                ? (translations.productUpdated || 'Product updated successfully!')
                : (translations.productSaved || 'Product saved successfully!');
            
            if (itemSaved && existingItemId) {
                successMessage += ' ✓ Added to items list';
            } else if (!itemSaved && existingItemId) {
                successMessage += ' ✓ Already in items list';
            } else {
                successMessage += ' (Not added to items list)';
            }

            showToast('success', successMessage);
            console.log('✅ Product saved successfully!');

            const draftKey = getDraftStorageKey();
            localStorage.removeItem(draftKey);
            setHasDraft(false);
            lastDraftContentRef.current = '';

            // Update form state to keep the existing item ID
            setFormData(prev => ({
                ...prev,
                _selectedItemId: existingItemId || null
            }));

            if (!isEditMode) {
                setFormData({
                    date: new Date().toISOString().split('T')[0],
                    batch_no: '',
                    barcode: '',
                    product_name: '',
                    product_code: '',
                    category: '',
                    company: '',
                    packing_type: '',
                    sub_packing_type: '',
                    items_per_pack: '',
                    unit_of_measure: '',
                    unitorstrip: '',
                    sell_per_pack: '',
                    total_quantity: '',
                    quantity_alert: '',
                    expiry_date: '',
                    sell_price_per_unit: '',
                    bquantity: '',
                    purchase_type: 'packing',
                    themeColor: formData.themeColor,
                    mrp: '',
                    trade_percent: '',
                    extra_percent: '',
                    bonus_buy: '',
                    bonus_free: '',
                    effective_cost_price: '',
                    effective_discount_percent: '',
                    mrp_per_pack_unit: '',
                    mrp_per_base_unit: '',
                    cost_price_per_pack_unit: '',
                    cost_price_per_base_unit: '',
                    pack_content_quantity: '',
                    pack_content_label: '',
                    pack_base_unit_label: '',
                    sell_price_per_item_unit: '',
                    sell_price_per_base_unit: '',
                    bonus_stock_quantity: '',
                    actual_stock_quantity: '',
                    _selectedItemId: existingItemId || null
                });
                setCategorySearchTerm('');
                setPackingTypeSearchTerm('');
                setSubPackingSearchTerm('');
                setUnitSearchTerm('');
                setProductSearchTerm('');
                setSelectedProduct(null);
                setErrors({});
                lastProductDataRef.current = '';
                setCalculatedSellPerPack('');
                setCalculatedBQuantity('');
                searchCache.current = {};

                setTimeout(() => {
                    if (productNameRef.current) {
                        productNameRef.current.focus();
                    }
                }, 100);
            } else {
                if (data.bquantity) {
                    setCalculatedBQuantity(data.bquantity);
                    setFormData(prev => ({
                        ...prev,
                        bquantity: data.bquantity,
                        total_quantity: data.total_quantity !== undefined ? data.total_quantity : prev.total_quantity
                    }));
                }
            }

            if (onSuccess) onSuccess(data.productid || productId);
        } else {
            console.error('❌ API error:', data);
            showToast('error', data.message || (isEditMode
                ? translations.failedUpdate
                : translations.failedAdd) || 'Operation failed');
            lastProductDataRef.current = '';
        }
    } catch (error) {
        if (error.name === 'AbortError') {
            showToast('error', 'Request timeout. Please try again.');
        } else {
            console.error('❌ Submit error:', error);
            showToast('error', error.message || translations.networkError || 'Network error');
        }
        lastProductDataRef.current = '';
    } finally {
        setTimeout(() => {
            isSubmittingRef.current = false;
            setLoading(false);
            if (submitButton) submitButton.disabled = false;
        }, 3000);
    }
};

    // ============================================
    // CLEAR HANDLER
    // ============================================
    const handleClear = () => {
        isClearingRef.current = true;
        const draftKey = getDraftStorageKey();
        localStorage.removeItem(draftKey);
        setHasDraft(false);
        lastDraftContentRef.current = '';
        searchCache.current = {};

        setFormData({
            date: new Date().toISOString().split('T')[0],
            batch_no: '',
            barcode: '',
            product_name: '',
            product_code: '',
            category: '',
            company: '',
            packing_type: '',
            sub_packing_type: '',
            items_per_pack: '',
            unit_of_measure: '',
            unitorstrip: '',
            sell_per_pack: '',
            total_quantity: '',
            quantity_alert: '',
            expiry_date: '',
            sell_price_per_unit: '',
            bquantity: '',
            purchase_type: 'packing',
            themeColor: formData.themeColor,
            mrp: '',
            trade_percent: '',
            extra_percent: '',
            bonus_buy: '',
            bonus_free: '',
            effective_cost_price: '',
            effective_discount_percent: '',
            mrp_per_pack_unit: '',
            mrp_per_base_unit: '',
            cost_price_per_pack_unit: '',
            cost_price_per_base_unit: '',
            pack_content_quantity: '',
            pack_content_label: '',
            pack_base_unit_label: '',
            sell_price_per_item_unit: '',
            sell_price_per_base_unit: '',
            bonus_stock_quantity: '',
            actual_stock_quantity: '',
            _selectedItemId: null
        });
        setCategorySearchTerm('');
        setPackingTypeSearchTerm('');
        setSubPackingSearchTerm('');
        setUnitSearchTerm('');
        setProductSearchTerm('');
        setSelectedProduct(null);
        setErrors({});
        setIsEditMode(false);
        lastProductDataRef.current = '';
        setCalculatedSellPerPack('');
        setCalculatedBQuantity('');

        showToast('success', translations.draftCleared || 'Form cleared');

        setTimeout(() => {
            if (productNameRef.current) {
                productNameRef.current.focus();
            }
        }, 100);

        setTimeout(() => {
            isClearingRef.current = false;
        }, 500);
    };

    const handleSwitchShop = async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                const draftKey = getDraftStorageKey();
                localStorage.removeItem(draftKey);
                setHasDraft(false);
                setCalculatedSellPerPack('');
                setCalculatedBQuantity('');
                setCategorySearchTerm('');
                setPackingTypeSearchTerm('');
                setSubPackingSearchTerm('');
                setUnitSearchTerm('');
                setProductSearchTerm('');
                setSelectedProduct(null);
                lastDraftContentRef.current = '';
                searchCache.current = {};
                setFormData(prev => ({ 
                    ...prev, 
                    _selectedItemId: null,
                    unitorstrip: ''
                }));
            }
            showToast(success ? 'success' : 'error',
                success ? (translations.shopSwitched || 'Shop switched successfully')
                    : (translations.shopSwitchFailed || 'Failed to switch shop'));
        } catch (error) {
            showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
        }
    };

    // ============================================
    // RENDER SHOP INDICATOR
    // ============================================
    const renderShopIndicator = () => {
        if (!currentShop) {
            return (
                <div className="pharmacy-shop-indicator no-shop">
                    <div className="pharmacy-shop-badge">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span className="pharmacy-shop-warning">
                            {translations.noShopSelected || 'No shop selected'}
                        </span>
                    </div>
                    <button
                        className="pharmacy-header-shop-btn"
                        onClick={() => setShowShopSelector(true)}
                    >
                        <FontAwesomeIcon icon={faExchangeAlt} />
                        <span>{translations.switchShop || 'Switch Shop'}</span>
                    </button>
                </div>
            );
        }
        return <div className="pharmacy-shop-indicator"></div>;
    };

    // ============================================
    // HELPER FUNCTIONS FOR DYNAMIC LABELS
    // ============================================
    const getPackingLabel = () => {
        const packingType = formData.packing_type;
        if (packingType) {
            const packingOption = packingTypes.find(p => p.value === packingType);
            return packingOption ? packingOption.label : packingType.charAt(0).toUpperCase() + packingType.slice(1);
        }
        return '';
    };

    const getSubPackingLabel = () => {
        const subPackingType = formData.sub_packing_type;
        if (subPackingType) {
            const subOption = availableSubPackings.find(s => s.value === subPackingType);
            return subOption ? subOption.label : subPackingType.charAt(0).toUpperCase() + subPackingType.slice(1);
        }
        return '';
    };

    const getUnitLabel = () => {
        return getUnitDisplayLabel(formData.unit_of_measure) || 'Unit';
    };

    const getBaseUnitLabel = () => {
        return formData.pack_base_unit_label || 'Unit';
    };

    // Calculate profit margins
    const calculateMargins = () => {
        const mrp = parseFloat(formData.mrp) || 0;
        const costPrice = parseFloat(formData.effective_cost_price) || 0;
        const itemsPerPack = parseFloat(formData.items_per_pack) || 1;
        const totalBaseUnits = parseFloat(formData.pack_content_quantity) || 1;

        const marginPerPack = mrp - costPrice;
        const marginPerPackPercent = costPrice > 0 ? ((marginPerPack / costPrice) * 100) : 0;

        const mrpPerUnit = itemsPerPack > 0 ? mrp / itemsPerPack : 0;
        const costPerUnit = itemsPerPack > 0 ? costPrice / itemsPerPack : 0;
        const marginPerUnit = mrpPerUnit - costPerUnit;
        const marginPerUnitPercent = costPerUnit > 0 ? ((marginPerUnit / costPerUnit) * 100) : 0;

        const mrpPerBase = totalBaseUnits > 0 ? mrp / totalBaseUnits : 0;
        const costPerBase = totalBaseUnits > 0 ? costPrice / totalBaseUnits : 0;
        const marginPerBase = mrpPerBase - costPerBase;
        const marginPerBasePercent = costPerBase > 0 ? ((marginPerBase / costPerBase) * 100) : 0;

        return {
            marginPerPack,
            marginPerPackPercent,
            marginPerUnit,
            marginPerUnitPercent,
            marginPerBase,
            marginPerBasePercent,
            mrpPerUnit,
            costPerUnit,
            mrpPerBase,
            costPerBase
        };
    };

    // ============================================
    // MAIN RENDER
    // ============================================
    return (
        <div className={`pharmacy-container ${isRTL ? 'pharmacy-rtl' : 'pharmacy-ltr'} ${darkMode ? 'pharmacy-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            {/* Sticky Header */}
            <div className="pharmacy-sticky-header">
                <div className="pharmacy-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="pharmacy-header-content">
                    <div className="pharmacy-header-left">
                        <div className="pharmacy-header-title">
                            <h1>{isEditMode ? (translations.editProduct || 'Edit Stock') : (translations.addProduct || 'Add Stock')}</h1>
                            <p>{translations.fillDetails || 'Fill in the stock details below'}</p>
                        </div>
                    </div>

                    <div className="pharmacy-header-right">
                        {renderShopIndicator()}

                        <div className="pharmacy-header-actions">
                            <button
                                className="pharmacy-action-btn clear-draft"
                                onClick={handleClear}
                                disabled={loading}
                                title={translations.clearButton || 'Clear Form'}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                                <span>{translations.clearButton || 'Clear'}</span>
                            </button>

                            <button
                                className="pharmacy-action-btn save-draft"
                                onClick={() => saveDraft()}
                                disabled={loading || isEditMode}
                                title={translations.saveDraft || 'Save as Draft'}
                            >
                                <FontAwesomeIcon icon={faFileAlt} />
                                <span>{translations.saveDraft || 'Save Draft'}</span>
                            </button>

                            <div className="pharmacy-drafts-dropdown-container" ref={draftsDropdownRef}>
                                <button
                                    className="pharmacy-action-btn drafts-btn"
                                    onClick={() => setShowDraftsList(!showDraftsList)}
                                    title={translations.viewDrafts || 'View Drafts'}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    <span>{translations.drafts || 'Drafts'}</span>
                                    {savedDrafts.length > 0 && <span className="drafts-badge">{savedDrafts.length}</span>}
                                </button>

                                {showDraftsList && (
                                    <div className="pharmacy-drafts-dropdown">
                                        <div className="drafts-header">
                                            <h4>{translations.savedDrafts || 'Saved Drafts'}</h4>
                                            <button onClick={() => setShowDraftsList(false)}>×</button>
                                        </div>
                                        <div className="drafts-list">
                                            {savedDrafts.length === 0 ? (
                                                <div className="no-drafts">{translations.noDraftsSaved || 'No drafts saved'}</div>
                                            ) : (
                                                savedDrafts.map(draft => (
                                                    <div key={draft.id} className="draft-item">
                                                        <div className="draft-info" onClick={() => loadDraft(draft)}>
                                                            <div className="draft-name">
                                                                {draft.product_name || 'Unnamed Product'}
                                                            </div>
                                                            <div className="draft-details">
                                                                {draft.batch_no && <span>Batch: {draft.batch_no}</span>}
                                                                {draft.company && <span>{draft.company}</span>}
                                                            </div>
                                                            <div className="draft-date">
                                                                {new Date(draft.savedAt).toLocaleDateString()}
                                                            </div>
                                                        </div>
                                                        <button
                                                            className="delete-draft-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                deleteDraft(draft.id);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </button>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* TWO COLUMN LAYOUT */}
            <div className="pharmacy-form-layout">
                {/* LEFT SIDE - 3 Columns */}
                <div className="pharmacy-form-left">
                    <form onSubmit={handleSubmit} className="pharmacy-form">
                        <div className="pharmacy-form-row">
                            {/* 1. Date */}
                            <div className={`pharmacy-field ${errors.date ? 'pharmacy-error' : ''}`}>
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="date"
                                        name="date"
                                        id="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="date">
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                        {translations.date || 'Date'}
                                    </label>
                                </div>
                            </div>

                            {/* 2. Product Name - SEARCHABLE DROPDOWN */}
                            <div className={`pharmacy-field ${errors.product_name ? 'pharmacy-error' : ''}`} ref={productDropdownRef}>
                                <div className="pharmacy-input-wrapper pharmacy-category-wrapper">
                                    <input
                                        ref={productNameRef}
                                        type="text"
                                        name="product_name"
                                        id="product_name"
                                        value={productSearchTerm || formData.product_name}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setProductSearchTerm(value);
                                            setFormData(prev => ({ ...prev, product_name: value }));
                                            if (selectedProduct && value !== selectedProduct.product_name) {
                                                setSelectedProduct(null);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    product_code: '',
                                                    company: '',
                                                    category: '',
                                                    _selectedItemId: null
                                                }));
                                                setCategorySearchTerm('');
                                            }
                                            setShowProductDropdown(true);
                                            if (errors.product_name) {
                                                setErrors(prev => ({ ...prev, product_name: '' }));
                                            }
                                        }}
                                        onFocus={() => {
                                            if (productSearchTerm && productSearchTerm.length >= 1) {
                                                setShowProductDropdown(true);
                                            }
                                        }}
                                        placeholder=" "
                                        disabled={loading}
                                        autoComplete="off"
                                    />
                                    <label htmlFor="product_name">
                                        <FontAwesomeIcon icon={faBox} />
                                        {translations.productName || 'Product Name'} <span>*</span>
                                    </label>
                                    <FontAwesomeIcon icon={faChevronDown} className="pharmacy-dropdown-arrow" />
                                </div>
                                {errors.product_name && <small>{errors.product_name}</small>}

                                {showProductDropdown && (
                                    <div className="pharmacy-category-dropdown product-search-dropdown">
                                        {productSearchResults.length > 0 ? (
                                            productSearchResults.map(product => (
                                                <div
                                                    key={product.id}
                                                    className={`pharmacy-category-option ${selectedProduct?.id === product.id ? 'pharmacy-selected' : ''}`}
                                                    onClick={() => handleProductSelect(product)}
                                                >
                                                    <div className="product-search-item">
                                                        <div className="product-search-name">
                                                            <strong>{product.product_name}</strong>
                                                            {product.product_code && (
                                                                <span className="product-search-code">({product.product_code})</span>
                                                            )}
                                                        </div>
                                                        {product.company && (
                                                            <div className="product-search-company">{product.company}</div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="pharmacy-category-empty">
                                                {productSearchTerm && productSearchTerm.length >= 1 ? (
                                                    <>No matching items — "{productSearchTerm}" will be added as a new product.</>
                                                ) : (
                                                    <>Start typing to search items</>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* 3. Batch Number */}
                            <div className={`pharmacy-field ${errors.batch_no ? 'pharmacy-error' : ''}`}>
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        ref={batchNoRef}
                                        type="text"
                                        name="batch_no"
                                        id="batch_no"
                                        value={formData.batch_no}
                                        onChange={handleChange}
                                        placeholder=" "
                                        disabled={loading}
                                        className="manual-input"
                                    />
                                    <label htmlFor="batch_no">
                                        <FontAwesomeIcon icon={faTag} />
                                        {translations.batchNumber || 'Batch Number'} <span>*</span>
                                    </label>
                                </div>
                                {errors.batch_no && <small>{errors.batch_no}</small>}
                            </div>

                            {/* 4. Barcode */}
                            <div className="pharmacy-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="barcode"
                                        id="barcode"
                                        value={formData.barcode}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                    />
                                    <label htmlFor="barcode">
                                        <FontAwesomeIcon icon={faBarcode} />
                                        {translations.barcode || 'Barcode'}
                                    </label>
                                </div>
                            </div>

                            {/* 5. Category */}
                            <div className="pharmacy-field" ref={categoryDropdownRef}>
                                <div className="pharmacy-input-wrapper pharmacy-category-wrapper">
                                    <input
                                        type="text"
                                        id="category"
                                        value={categorySearchTerm}
                                        onChange={(e) => {
                                            setCategorySearchTerm(e.target.value);
                                            setShowCategoryDropdown(true);
                                            if (formData.category && !categoryOptions.find(c =>
                                                c.label.toLowerCase() === e.target.value.toLowerCase()
                                            )) {
                                                setFormData(prev => ({ ...prev, category: '' }));
                                            }
                                        }}
                                        onFocus={() => setShowCategoryDropdown(true)}
                                        placeholder=" "
                                        disabled={loading}
                                        autoComplete="off"
                                    />
                                    <label htmlFor="category">
                                        <FontAwesomeIcon icon={faTag} />
                                        {translations.category || 'Category'}
                                    </label>
                                    <FontAwesomeIcon icon={faChevronDown} className="pharmacy-dropdown-arrow" />
                                </div>
                                {showCategoryDropdown && (
                                    <div className="pharmacy-category-dropdown">
                                        {filteredCategories.length > 0 ? (
                                            filteredCategories.map(cat => (
                                                <div
                                                    key={cat.value}
                                                    className={`pharmacy-category-option ${formData.category === cat.value ? 'pharmacy-selected' : ''}`}
                                                    onClick={() => selectCategory(cat)}
                                                >
                                                    {cat.label}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="pharmacy-category-empty">No categories found</div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* 6. Manufacturer */}
                            <div className="pharmacy-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="company"
                                        id="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="company">
                                        <FontAwesomeIcon icon={faBuilding} />
                                        {translations.company || 'Company / Brand'}
                                    </label>
                                </div>
                            </div>

                            {/* 7. Packing Type */}
                            <div className={`pharmacy-field ${errors.packing_type ? 'pharmacy-error' : ''}`} ref={packingTypeDropdownRef}>
                                <div className="pharmacy-input-wrapper pharmacy-category-wrapper">
                                    <input
                                        type="text"
                                        id="packing_type"
                                        value={packingTypeSearchTerm}
                                        onChange={(e) => {
                                            setPackingTypeSearchTerm(e.target.value);
                                            setShowPackingTypeDropdown(true);
                                            if (formData.packing_type && !packingTypes.find(p =>
                                                p.label.toLowerCase() === e.target.value.toLowerCase()
                                            )) {
                                                setFormData(prev => ({ ...prev, packing_type: '', sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                                                setSubPackingSearchTerm('');
                                                setUnitSearchTerm('');
                                            }
                                        }}
                                        onFocus={() => setShowPackingTypeDropdown(true)}
                                        placeholder=" "
                                        disabled={loading}
                                        autoComplete="off"
                                    />
                                    <label htmlFor="packing_type">
                                        <FontAwesomeIcon icon={faBox} />
                                        {translations.packingType || 'Packing Type'} <span>*</span>
                                    </label>
                                    <FontAwesomeIcon icon={faChevronDown} className="pharmacy-dropdown-arrow" />
                                </div>
                                {errors.packing_type && <small>{errors.packing_type}</small>}
                                {showPackingTypeDropdown && (
                                    <div className="pharmacy-category-dropdown">
                                        {filteredPackingTypes.length > 0 ? (
                                            filteredPackingTypes.map(pt => (
                                                <div
                                                    key={pt.value}
                                                    className={`pharmacy-category-option ${formData.packing_type === pt.value ? 'pharmacy-selected' : ''}`}
                                                    onClick={() => selectPackingType(pt)}
                                                >
                                                    {pt.label}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="pharmacy-category-empty">No packing types found</div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* 8. Sub Packing Type */}
                            <div className={`pharmacy-field ${errors.sub_packing_type ? 'pharmacy-error' : ''}`} ref={subPackingDropdownRef}>
                                <div className="pharmacy-input-wrapper pharmacy-category-wrapper">
                                    <input
                                        type="text"
                                        id="sub_packing_type"
                                        value={subPackingSearchTerm}
                                        onChange={(e) => {
                                            setSubPackingSearchTerm(e.target.value);
                                            setShowSubPackingDropdown(true);
                                            if (formData.sub_packing_type && !availableSubPackings.find(s =>
                                                s.label.toLowerCase() === e.target.value.toLowerCase()
                                            )) {
                                                setFormData(prev => ({ ...prev, sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                                                setUnitSearchTerm('');
                                            }
                                        }}
                                        onFocus={() => {
                                            if (formData.packing_type) {
                                                setShowSubPackingDropdown(true);
                                            }
                                        }}
                                        placeholder=" "
                                        disabled={loading || !formData.packing_type}
                                        autoComplete="off"
                                    />
                                    <label htmlFor="sub_packing_type">
                                        <FontAwesomeIcon icon={faLayerGroup} />
                                        {translations.subPackingType || 'Sub Packing Type'} <span>*</span>
                                    </label>
                                    <FontAwesomeIcon icon={faChevronDown} className="pharmacy-dropdown-arrow" />
                                </div>
                                {errors.sub_packing_type && <small>{errors.sub_packing_type}</small>}
                                {showSubPackingDropdown && formData.packing_type && (
                                    <div className="pharmacy-category-dropdown">
                                        {filteredSubPackings.length > 0 ? (
                                            filteredSubPackings.map(sub => (
                                                <div
                                                    key={sub.value}
                                                    className={`pharmacy-category-option ${formData.sub_packing_type === sub.value ? 'pharmacy-selected' : ''}`}
                                                    onClick={() => handleSubPackingChange(sub.value, sub.label)}
                                                >
                                                    {sub.label}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="pharmacy-category-empty">No sub packing types found</div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* 9. Units Per Pack */}
                            <div className={`pharmacy-field ${errors.items_per_pack ? 'pharmacy-error' : ''}`}>
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="number"
                                        name="items_per_pack"
                                        id="items_per_pack"
                                        value={formData.items_per_pack}
                                        onChange={handleChange}
                                        required
                                        step="1"
                                        min="0"
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="items_per_pack">
                                        <FontAwesomeIcon icon={faCalculator} />
                                        Items Per Pack <span>*</span>
                                    </label>
                                </div>
                                {errors.items_per_pack && <small>{errors.items_per_pack}</small>}
                            </div>

                            {/* 10. Unit of Measure */}
                            <div className={`pharmacy-field ${errors.unit_of_measure ? 'pharmacy-error' : ''}`} ref={unitDropdownRef}>
                                <div className="pharmacy-input-wrapper pharmacy-category-wrapper">
                                    <input
                                        type="text"
                                        id="unit_of_measure"
                                        value={unitSearchTerm}
                                        onChange={(e) => {
                                            setUnitSearchTerm(e.target.value);
                                            setShowUnitDropdown(true);
                                            if (formData.unit_of_measure && !unitsOfMeasure.find(u =>
                                                u.label.toLowerCase() === e.target.value.toLowerCase()
                                            )) {
                                                setFormData(prev => ({ ...prev, unit_of_measure: '' }));
                                            }
                                        }}
                                        onFocus={() => setShowUnitDropdown(true)}
                                        placeholder=" "
                                        disabled={loading}
                                        autoComplete="off"
                                    />
                                    <label htmlFor="unit_of_measure">
                                        <FontAwesomeIcon icon={faBalanceScale} />
                                        {translations.unitOfMeasure || 'Unit of Measure'} <span>*</span>
                                    </label>
                                    <FontAwesomeIcon icon={faChevronDown} className="pharmacy-dropdown-arrow" />
                                </div>
                                {errors.unit_of_measure && <small>{errors.unit_of_measure}</small>}
                                {showUnitDropdown && (
                                    <div className="pharmacy-category-dropdown">
                                        {filteredUnits.length > 0 ? (
                                            filteredUnits.map(unit => (
                                                <div
                                                    key={unit.value}
                                                    className={`pharmacy-category-option ${formData.unit_of_measure === unit.value ? 'pharmacy-selected' : ''}`}
                                                    onClick={() => selectUnit(unit)}
                                                >
                                                    {unit.label}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="pharmacy-category-empty">No units found</div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* 11. MRP - Maximum Retail Price */}
                            <div className={`pharmacy-field ${errors.mrp ? 'pharmacy-error' : ''}`}>
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="number"
                                        name="mrp"
                                        id="mrp"
                                        value={formData.mrp}
                                        onChange={handleChange}
                                        step="0.01"
                                        min="0"
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="mrp">
                                        <FontAwesomeIcon icon={faRupeeSign} />
                                        {`MRP per ${getPackingLabel() || 'Pack'}`}
                                    </label>
                                </div>
                                {errors.mrp && <small>{errors.mrp}</small>}
                            </div>

                            {/* 12. MRP per Pack/Unit - Auto-calculated */}
                            <div className="pharmacy-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="mrp_per_pack_unit"
                                        id="mrp_per_pack_unit"
                                        value={formData.mrp_per_pack_unit}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field pharmacy-per-unit-price"
                                    />
                                    <label htmlFor="mrp_per_pack_unit">
                                        <FontAwesomeIcon icon={faBoxes} />
                                        {`MRP per ${getUnitLabel()}`}
                                    </label>
                                </div>
                            </div>

                            {/* 13. MRP per Tablet/Capsule - Auto-calculated */}
                            <div className="pharmacy-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="mrp_per_base_unit"
                                        id="mrp_per_base_unit"
                                        value={formData.mrp_per_base_unit}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field pharmacy-per-unit-price"
                                    />
                                    <label htmlFor="mrp_per_base_unit">
                                        <FontAwesomeIcon icon={faPills} />
                                        {`MRP per ${getBaseUnitLabel()}`}
                                    </label>
                                </div>
                            </div>

                            {/* 16. Pack Content */}
                            <div className="pharmacy-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="pack_content_label"
                                        id="pack_content_label"
                                        value={formData.pack_content_label}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field pharmacy-per-unit-price"
                                    />
                                    <label htmlFor="pack_content_label">
                                        <FontAwesomeIcon icon={faCubes} />
                                        {`Total ${getPluralUnitLabel(getBaseUnitLabel())}`}
                                    </label>
                                </div>
                            </div>

                            {/* 17. Total Quantity */}
                            <div className={`pharmacy-field ${errors.total_quantity ? 'pharmacy-error' : ''}`}>
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="number"
                                        name="total_quantity"
                                        id="total_quantity"
                                        value={formData.total_quantity}
                                        onChange={handleChange}
                                        required
                                        step="0.001"
                                        min="0"
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="total_quantity">
                                        <FontAwesomeIcon icon={faWarehouse} />
                                        {translations.totalQuantity || 'Total Quantity'} <span>*</span>
                                        {formData.bonus_stock_quantity && <span className="field-hint">(Purchased)</span>}
                                    </label>
                                </div>
                                {errors.total_quantity && <small>{errors.total_quantity}</small>}
                            </div>

                            {/* 19. Low Stock Alert */}
                            <div className={`pharmacy-field ${errors.quantity_alert ? 'pharmacy-error' : ''}`}>
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="number"
                                        name="quantity_alert"
                                        id="quantity_alert"
                                        value={formData.quantity_alert}
                                        onChange={handleChange}
                                        required
                                        step="0.001"
                                        min="0"
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="quantity_alert">
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                        {translations.quantityAlert || 'Low Stock Alert'} <span>*</span>
                                    </label>
                                </div>
                                {errors.quantity_alert && <small>{errors.quantity_alert}</small>}
                            </div>

                            {/* 20. Expiry Date */}
                            <div className={`pharmacy-field ${errors.expiry_date ? 'pharmacy-error' : ''}`}>
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="date"
                                        name="expiry_date"
                                        id="expiry_date"
                                        value={formData.expiry_date}
                                        onChange={handleChange}
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="expiry_date">
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                        {translations.expiryDate || 'Expiry Date'}
                                    </label>
                                </div>
                                {errors.expiry_date && <small>{errors.expiry_date}</small>}
                            </div>

                            {/* 21. BQuantity */}
                            <div className="pharmacy-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="bquantity"
                                        id="bquantity"
                                        value={formData.bquantity || calculatedBQuantity}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field"
                                    />
                                    <label htmlFor="bquantity">
                                        <FontAwesomeIcon icon={faCubes} />
                                        {translations.bquantity || 'BQuantity (Bulk Quantity)'}
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Form Actions */}
                        <div className="pharmacy-form-actions">
                            <button
                                type="submit"
                                className="pharmacy-btn pharmacy-btn-primary"
                                disabled={loading || !currentShop || isSubmittingRef.current}
                            >
                                {loading ? (
                                    <>
                                        <FontAwesomeIcon icon={faSpinner} spin />
                                        <span>{isEditMode ? (translations.updating || 'Updating...') : (translations.adding || 'Adding...')}</span>
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faSave} />
                                        <span>{isEditMode ? (translations.updateProduct || 'Update Product') : (translations.addProductButton || 'Save Product')}</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>

                {/* RIGHT SIDEBAR - Fixed 4 Sections */}
                <div className="pharmacy-form-right">
                    {/* Section 1: Discounts (TP% + Extra%) */}
                    <div className="pharmacy-sidebar-section">
                        <div className="pharmacy-sidebar-section-title">
                            <FontAwesomeIcon icon={faPercent} />
                            {translations.discounts || 'Discounts'}
                        </div>
                        <div className="pharmacy-sidebar-fields-grid">
                            <div className="pharmacy-sidebar-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="number"
                                        name="trade_percent"
                                        id="trade_percent"
                                        value={formData.trade_percent}
                                        onChange={handleChange}
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="trade_percent">
                                        <FontAwesomeIcon icon={faPercent} />
                                        TP
                                    </label>
                                </div>
                                {errors.trade_percent && <small>{errors.trade_percent}</small>}
                            </div>
                            <div className="pharmacy-sidebar-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="number"
                                        name="extra_percent"
                                        id="extra_percent"
                                        value={formData.extra_percent}
                                        onChange={handleChange}
                                        step="0.01"
                                        min="0"
                                        max="100"
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="extra_percent">
                                        <FontAwesomeIcon icon={faPercent} />
                                        Extra
                                    </label>
                                </div>
                                {errors.extra_percent && <small>{errors.extra_percent}</small>}
                            </div>
                            <div className="pharmacy-sidebar-field full-width">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="effective_discount_percent"
                                        id="effective_discount_percent"
                                        value={formData.effective_discount_percent}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field pharmacy-per-unit-price"
                                    />
                                    <label htmlFor="effective_discount_percent">
                                        <FontAwesomeIcon icon={faPercent} />
                                        {translations.effectiveDiscountPercent || 'Effective Discount'}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 2: Bonus Details */}
                    <div className="pharmacy-sidebar-section">
                        <div className="pharmacy-sidebar-section-title">
                            <FontAwesomeIcon icon={faGift} />
                            {translations.bonusDetails || 'Bonus Details'}
                        </div>
                        <div className="pharmacy-sidebar-fields-grid">
                            <div className="pharmacy-sidebar-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="number"
                                        name="bonus_buy"
                                        id="bonus_buy"
                                        value={formData.bonus_buy}
                                        onChange={handleChange}
                                        step="1"
                                        min="0"
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="bonus_buy">
                                        <FontAwesomeIcon icon={faBoxes} />
                                        Buy
                                    </label>
                                </div>
                                {errors.bonus_buy && <small>{errors.bonus_buy}</small>}
                            </div>
                            <div className="pharmacy-sidebar-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="number"
                                        name="bonus_free"
                                        id="bonus_free"
                                        value={formData.bonus_free}
                                        onChange={handleChange}
                                        step="1"
                                        min="0"
                                        placeholder=" "
                                        disabled={loading}
                                    />
                                    <label htmlFor="bonus_free">
                                        <FontAwesomeIcon icon={faBoxes} />
                                        Free
                                    </label>
                                </div>
                                {errors.bonus_free && <small>{errors.bonus_free}</small>}
                            </div>
                            {/* Bonus Stock Quantity - Auto */}
                            <div className="pharmacy-sidebar-field full-width">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="bonus_stock_quantity"
                                        id="bonus_stock_quantity"
                                        value={formData.bonus_stock_quantity}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field pharmacy-per-unit-price"
                                    />
                                    <label htmlFor="bonus_stock_quantity">
                                        <FontAwesomeIcon icon={faBoxes} />
                                        {translations.bonusStockQuantity || 'Bonus Stock Qty'}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 3: Cost Prices */}
                    <div className="pharmacy-sidebar-section">
                        <div className="pharmacy-sidebar-section-title">
                            <FontAwesomeIcon icon={faCoins} />
                            {translations.costPrices || 'Cost Prices'}
                        </div>
                        <div className="pharmacy-sidebar-fields-grid">
                            {/* Row 1, Col 1: Cost Price (per Pack) */}
                            <div className="pharmacy-sidebar-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="effective_cost_price"
                                        id="effective_cost_price"
                                        value={formData.effective_cost_price}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field pharmacy-per-unit-price"
                                    />
                                    <label htmlFor="effective_cost_price">
                                        <FontAwesomeIcon icon={faRupeeSign} />
                                        {`${translations.effectiveCostPrice || 'Cost Price'}`}
                                    </label>
                                </div>
                            </div>
                            {/* Row 1, Col 2: Per Pack Label */}
                            <div className="pharmacy-sidebar-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field"
                                        value={getPackingLabel() || 'Pack'}
                                        style={{ textAlign: 'center', fontWeight: '600', fontSize: '0.8rem' }}
                                    />
                                    <label style={{ color: 'var(--pharmacy-text-light)', fontSize: '0.6rem', fontWeight: '400' }}>
                                        <FontAwesomeIcon icon={faBox} />
                                        Per {getPackingLabel() || 'Pack'}
                                    </label>
                                </div>
                            </div>
                            {/* Row 2, Col 1: Cost Price per Unit */}
                            <div className="pharmacy-sidebar-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="cost_price_per_pack_unit"
                                        id="cost_price_per_pack_unit"
                                        value={formData.cost_price_per_pack_unit}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field pharmacy-per-unit-price"
                                    />
                                    <label htmlFor="cost_price_per_pack_unit">
                                        <FontAwesomeIcon icon={faBoxes} />
                                        {`Per ${getUnitLabel()}`}
                                    </label>
                                </div>
                            </div>
                            {/* Row 2, Col 2: Cost Price per Base Unit */}
                            <div className="pharmacy-sidebar-field">
                                <div className="pharmacy-input-wrapper">
                                    <input
                                        type="text"
                                        name="cost_price_per_base_unit"
                                        id="cost_price_per_base_unit"
                                        value={formData.cost_price_per_base_unit}
                                        readOnly
                                        placeholder=" "
                                        disabled
                                        className="readonly-field pharmacy-per-unit-price"
                                    />
                                    <label htmlFor="cost_price_per_base_unit">
                                        <FontAwesomeIcon icon={faPills} />
                                        {`Per ${getBaseUnitLabel()}`}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PharmacyProductTax;